"use client";

import React, { useState, useMemo } from "react";
import { ArrowUpRight, ArrowDownRight, ChevronLeft, ChevronRight } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const backtestTrades = [{
  tradeNumber: 1,
  date: "2021-05-03",
  duration: "3m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2,
  date: "2021-05-04",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.58
}, {
  tradeNumber: 3,
  date: "2021-05-05",
  duration: "6h 02m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.35
}, {
  tradeNumber: 4,
  date: "2021-05-06",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 5,
  date: "2021-05-07",
  duration: "37m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 6,
  date: "2021-05-10",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 10.54
}, {
  tradeNumber: 7,
  date: "2021-05-11",
  duration: "6h 28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 8.18
}, {
  tradeNumber: 8,
  date: "2021-05-12",
  duration: "1m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 9,
  date: "2021-05-13",
  duration: "1h 45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 10,
  date: "2021-05-13",
  duration: "2h 13m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 11,
  date: "2021-05-13",
  duration: "13h 38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 12,
  date: "2021-05-14",
  duration: "41m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 13,
  date: "2021-05-14",
  duration: "28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 14,
  date: "2021-05-17",
  duration: "20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 15,
  date: "2021-05-18",
  duration: "1h 01m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 16,
  date: "2021-05-20",
  duration: "5h 16m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 17,
  date: "2021-05-20",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 6.01
}, {
  tradeNumber: 18,
  date: "2021-05-21",
  duration: "13h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 19,
  date: "2021-05-21",
  duration: "9m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 20,
  date: "2021-05-24",
  duration: "3h 28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 21,
  date: "2021-05-24",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.35
}, {
  tradeNumber: 22,
  date: "2021-05-25",
  duration: "6h 08m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.28
}, {
  tradeNumber: 23,
  date: "2021-05-25",
  duration: "72h 50m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.83
}, {
  tradeNumber: 24,
  date: "2021-05-26",
  duration: "6h 17m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.48
}, {
  tradeNumber: 25,
  date: "2021-05-27",
  duration: "4h 47m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 26,
  date: "2021-05-28",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.3
}, {
  tradeNumber: 27,
  date: "2021-05-28",
  duration: "68h 34m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 28,
  date: "2021-06-01",
  duration: "41m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 29,
  date: "2021-06-02",
  duration: "7h 49m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 30,
  date: "2021-06-02",
  duration: "3h 37m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 31,
  date: "2021-06-02",
  duration: "17h 09m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 32,
  date: "2021-06-03",
  duration: "8m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 33,
  date: "2021-06-04",
  duration: "4h 52m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 34,
  date: "2021-06-04",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 7.39
}, {
  tradeNumber: 35,
  date: "2021-06-07",
  duration: "3h 21m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 36,
  date: "2021-06-07",
  duration: "3h 11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.0
}, {
  tradeNumber: 37,
  date: "2021-06-08",
  duration: "1h 57m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 38,
  date: "2021-06-08",
  duration: "13m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 39,
  date: "2021-06-09",
  duration: "5h 02m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 40,
  date: "2021-06-09",
  duration: "22m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 41,
  date: "2021-06-09",
  duration: "11h 13m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 42,
  date: "2021-06-10",
  duration: "22m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 43,
  date: "2021-06-10",
  duration: "1h 05m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 44,
  date: "2021-06-11",
  duration: "6h 24m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 45,
  date: "2021-06-11",
  duration: "101h 10m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.52
}, {
  tradeNumber: 46,
  date: "2021-06-14",
  duration: "17m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 47,
  date: "2021-06-15",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.68
}, {
  tradeNumber: 48,
  date: "2021-06-16",
  duration: "41m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 49,
  date: "2021-06-16",
  duration: "2h 03m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.02
}, {
  tradeNumber: 50,
  date: "2021-06-17",
  duration: "181h 21m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 11.52
}, {
  tradeNumber: 51,
  date: "2021-06-17",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 12.43
}, {
  tradeNumber: 52,
  date: "2021-06-18",
  duration: "8m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 53,
  date: "2021-06-21",
  duration: "1h 07m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 54,
  date: "2021-06-22",
  duration: "3m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 55,
  date: "2021-06-23",
  duration: "49m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 56,
  date: "2021-06-24",
  duration: "4h 13m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.02
}, {
  tradeNumber: 57,
  date: "2021-06-25",
  duration: "8h 55m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 58,
  date: "2021-06-25",
  duration: "282h 02m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 18.88
}, {
  tradeNumber: 59,
  date: "2021-06-28",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 5.52
}, {
  tradeNumber: 60,
  date: "2021-06-29",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 61,
  date: "2021-06-29",
  duration: "28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 62,
  date: "2021-06-30",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 63,
  date: "2021-07-01",
  duration: "3m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 64,
  date: "2021-07-02",
  duration: "42m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 65,
  date: "2021-07-05",
  duration: "3h 12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.09
}, {
  tradeNumber: 66,
  date: "2021-07-06",
  duration: "1h 05m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 67,
  date: "2021-07-07",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 68,
  date: "2021-07-07",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 69,
  date: "2021-07-08",
  duration: "4m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 70,
  date: "2021-07-09",
  duration: "7h 50m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 71,
  date: "2021-07-09",
  duration: "2m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 72,
  date: "2021-07-12",
  duration: "3h 45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 73,
  date: "2021-07-12",
  duration: "6h 10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 74,
  date: "2021-07-13",
  duration: "23m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 75,
  date: "2021-07-13",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 76,
  date: "2021-07-13",
  duration: "4h 33m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 77,
  date: "2021-07-13",
  duration: "37m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 78,
  date: "2021-07-13",
  duration: "15h 40m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.71
}, {
  tradeNumber: 79,
  date: "2021-07-14",
  duration: "7m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 80,
  date: "2021-07-15",
  duration: "3h 55m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 81,
  date: "2021-07-16",
  duration: "1m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 82,
  date: "2021-07-16",
  duration: "1h 21m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 83,
  date: "2021-07-19",
  duration: "1h 06m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 84,
  date: "2021-07-20",
  duration: "8h 12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 85,
  date: "2021-07-20",
  duration: "18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 86,
  date: "2021-07-21",
  duration: "40m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 87,
  date: "2021-07-21",
  duration: "37m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 88,
  date: "2021-07-21",
  duration: "6h 02m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.38
}, {
  tradeNumber: 89,
  date: "2021-07-22",
  duration: "52m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 90,
  date: "2021-07-22",
  duration: "6h 17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.4
}, {
  tradeNumber: 91,
  date: "2021-07-23",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 92,
  date: "2021-07-23",
  duration: "40m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 93,
  date: "2021-07-26",
  duration: "2h 34m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 94,
  date: "2021-07-27",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 7.67
}, {
  tradeNumber: 95,
  date: "2021-07-27",
  duration: "14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 96,
  date: "2021-07-28",
  duration: "8h 20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 97,
  date: "2021-07-28",
  duration: "32m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 98,
  date: "2021-07-28",
  duration: "27h 15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 99,
  date: "2021-07-29",
  duration: "3m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 100,
  date: "2021-07-30",
  duration: "6h 16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.06
}, {
  tradeNumber: 101,
  date: "2021-08-02",
  duration: "6m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 102,
  date: "2021-08-04",
  duration: "50m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 103,
  date: "2021-08-05",
  duration: "81h 12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.18
}, {
  tradeNumber: 104,
  date: "2021-08-06",
  duration: "5h 11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.04
}, {
  tradeNumber: 105,
  date: "2021-08-09",
  duration: "6m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 106,
  date: "2021-08-10",
  duration: "12h 30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 107,
  date: "2021-08-10",
  duration: "6m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 108,
  date: "2021-08-11",
  duration: "1h 56m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 109,
  date: "2021-08-11",
  duration: "28h 45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 110,
  date: "2021-08-12",
  duration: "6m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 111,
  date: "2021-08-13",
  duration: "74h 14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 112,
  date: "2021-08-13",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.11
}, {
  tradeNumber: 113,
  date: "2021-08-16",
  duration: "19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 114,
  date: "2021-08-17",
  duration: "41m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 115,
  date: "2021-08-18",
  duration: "1h 31m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 116,
  date: "2021-08-19",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 7.86
}, {
  tradeNumber: 117,
  date: "2021-08-19",
  duration: "50m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 118,
  date: "2021-08-20",
  duration: "2h 24m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 119,
  date: "2021-08-20",
  duration: "6h 14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.83
}, {
  tradeNumber: 120,
  date: "2021-08-23",
  duration: "184h 07m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 19.79
}, {
  tradeNumber: 121,
  date: "2021-08-23",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 3.87
}, {
  tradeNumber: 122,
  date: "2021-08-24",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.4
}, {
  tradeNumber: 123,
  date: "2021-08-26",
  duration: "55m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 124,
  date: "2021-08-27",
  duration: "2m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 125,
  date: "2021-08-27",
  duration: "20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 126,
  date: "2021-08-30",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 6.86
}, {
  tradeNumber: 127,
  date: "2021-09-01",
  duration: "5h 40m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 128,
  date: "2021-09-01",
  duration: "14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 129,
  date: "2021-09-01",
  duration: "4h 51m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 130,
  date: "2021-09-01",
  duration: "21h 43m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 131,
  date: "2021-09-02",
  duration: "29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 132,
  date: "2021-09-03",
  duration: "9h 31m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 133,
  date: "2021-09-03",
  duration: "65h 21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 134,
  date: "2021-09-06",
  duration: "3h 28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.46
}, {
  tradeNumber: 135,
  date: "2021-09-07",
  duration: "1h 08m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 136,
  date: "2021-09-07",
  duration: "7m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 137,
  date: "2021-09-07",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 138,
  date: "2021-09-08",
  duration: "10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 139,
  date: "2021-09-08",
  duration: "12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 140,
  date: "2021-09-09",
  duration: "34h 01m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 141,
  date: "2021-09-09",
  duration: "1h 55m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.02
}, {
  tradeNumber: 142,
  date: "2021-09-10",
  duration: "37m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 143,
  date: "2021-09-10",
  duration: "19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 144,
  date: "2021-09-13",
  duration: "8h 33m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.14
}, {
  tradeNumber: 145,
  date: "2021-09-13",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.88
}, {
  tradeNumber: 146,
  date: "2021-09-13",
  duration: "17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 147,
  date: "2021-09-14",
  duration: "1h 46m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.16
}, {
  tradeNumber: 148,
  date: "2021-09-14",
  duration: "9m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 149,
  date: "2021-09-14",
  duration: "10h 20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.67
}, {
  tradeNumber: 150,
  date: "2021-09-15",
  duration: "10h 05m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 151,
  date: "2021-09-15",
  duration: "3h 01m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.02
}, {
  tradeNumber: 152,
  date: "2021-09-16",
  duration: "16h 30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.13
}, {
  tradeNumber: 153,
  date: "2021-09-16",
  duration: "3m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 154,
  date: "2021-09-16",
  duration: "4h 07m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 155,
  date: "2021-09-17",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 8.46
}, {
  tradeNumber: 156,
  date: "2021-09-20",
  duration: "1m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 157,
  date: "2021-09-22",
  duration: "9h 07m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 158,
  date: "2021-09-22",
  duration: "31m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 159,
  date: "2021-09-23",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.56
}, {
  tradeNumber: 160,
  date: "2021-09-23",
  duration: "20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 161,
  date: "2021-09-24",
  duration: "1h 52m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 162,
  date: "2021-09-24",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.61
}, {
  tradeNumber: 163,
  date: "2021-09-26",
  duration: "1h 04m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 164,
  date: "2021-09-27",
  duration: "1h 05m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 165,
  date: "2021-09-27",
  duration: "27m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 166,
  date: "2021-09-28",
  duration: "5h 59m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 167,
  date: "2021-09-28",
  duration: "3m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 168,
  date: "2021-09-29",
  duration: "10h 53m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.16
}, {
  tradeNumber: 169,
  date: "2021-09-29",
  duration: "19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 170,
  date: "2021-09-30",
  duration: "13h 06m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.29
}, {
  tradeNumber: 171,
  date: "2021-09-30",
  duration: "16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 172,
  date: "2021-10-01",
  duration: "7m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 173,
  date: "2021-10-01",
  duration: "6h 38m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.17
}, {
  tradeNumber: 174,
  date: "2021-10-01",
  duration: "2h 04m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 175,
  date: "2021-10-01",
  duration: "71h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.03
}, {
  tradeNumber: 176,
  date: "2021-10-04",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.67
}, {
  tradeNumber: 177,
  date: "2021-10-06",
  duration: "29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.02
}, {
  tradeNumber: 178,
  date: "2021-10-06",
  duration: "4h 41m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 179,
  date: "2021-10-07",
  duration: "4m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 180,
  date: "2021-10-08",
  duration: "7h 39m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.74
}, {
  tradeNumber: 181,
  date: "2021-10-08",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.84
}, {
  tradeNumber: 182,
  date: "2021-10-11",
  duration: "6h 18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.02
}, {
  tradeNumber: 183,
  date: "2021-10-11",
  duration: "3h 07m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 184,
  date: "2021-10-12",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 185,
  date: "2021-10-12",
  duration: "18h 08m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.2
}, {
  tradeNumber: 186,
  date: "2021-10-13",
  duration: "20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 187,
  date: "2021-10-13",
  duration: "120h 56m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 9.46
}, {
  tradeNumber: 188,
  date: "2021-10-15",
  duration: "59m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 189,
  date: "2021-10-18",
  duration: "6h 18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 3.92
}, {
  tradeNumber: 190,
  date: "2021-10-19",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.24
}, {
  tradeNumber: 191,
  date: "2021-10-20",
  duration: "33m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.02
}, {
  tradeNumber: 192,
  date: "2021-10-20",
  duration: "12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 193,
  date: "2021-10-21",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 5.27
}, {
  tradeNumber: 194,
  date: "2021-10-21",
  duration: "14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 195,
  date: "2021-10-21",
  duration: "23h 35m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.96
}, {
  tradeNumber: 196,
  date: "2021-10-22",
  duration: "13m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 197,
  date: "2021-10-25",
  duration: "7m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 198,
  date: "2021-10-26",
  duration: "2h 26m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.02
}, {
  tradeNumber: 199,
  date: "2021-10-26",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 200,
  date: "2021-10-27",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.39
}, {
  tradeNumber: 201,
  date: "2021-10-27",
  duration: "13m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 202,
  date: "2021-10-27",
  duration: "44m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 203,
  date: "2021-10-28",
  duration: "16m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 204,
  date: "2021-10-29",
  duration: "5h 10m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 205,
  date: "2021-10-29",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.53
}, {
  tradeNumber: 206,
  date: "2021-11-01",
  duration: "29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 207,
  date: "2021-11-01",
  duration: "3h 10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 208,
  date: "2021-11-02",
  duration: "2h 00m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 209,
  date: "2021-11-02",
  duration: "34m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 210,
  date: "2021-11-03",
  duration: "181h 37m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.77
}, {
  tradeNumber: 211,
  date: "2021-11-03",
  duration: "3m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 212,
  date: "2021-11-04",
  duration: "15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 213,
  date: "2021-11-05",
  duration: "19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 214,
  date: "2021-11-08",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 215,
  date: "2021-11-10",
  duration: "16m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 216,
  date: "2021-11-10",
  duration: "2h 44m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.75
}, {
  tradeNumber: 217,
  date: "2021-11-11",
  duration: "9m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 218,
  date: "2021-11-12",
  duration: "74h 09m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.02
}, {
  tradeNumber: 219,
  date: "2021-11-12",
  duration: "5h 12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.67
}, {
  tradeNumber: 220,
  date: "2021-11-15",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.29
}, {
  tradeNumber: 221,
  date: "2021-11-16",
  duration: "143h 42m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 13.37
}, {
  tradeNumber: 222,
  date: "2021-11-17",
  duration: "21m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 223,
  date: "2021-11-19",
  duration: "14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 224,
  date: "2021-11-22",
  duration: "4h 37m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 6.85
}, {
  tradeNumber: 225,
  date: "2021-11-23",
  duration: "4h 46m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 226,
  date: "2021-11-23",
  duration: "11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 227,
  date: "2021-11-24",
  duration: "9h 39m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.22
}, {
  tradeNumber: 228,
  date: "2021-11-24",
  duration: "13m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 229,
  date: "2021-11-25",
  duration: "25m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 230,
  date: "2021-11-26",
  duration: "3h 37m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.48
}, {
  tradeNumber: 231,
  date: "2021-11-26",
  duration: "13m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 232,
  date: "2021-11-29",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 233,
  date: "2021-11-30",
  duration: "40m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 234,
  date: "2021-12-01",
  duration: "1h 40m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 235,
  date: "2021-12-01",
  duration: "2h 23m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.18
}, {
  tradeNumber: 236,
  date: "2021-12-01",
  duration: "3h 04m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 8.16
}, {
  tradeNumber: 237,
  date: "2021-12-02",
  duration: "31m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 238,
  date: "2021-12-02",
  duration: "38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.82
}, {
  tradeNumber: 239,
  date: "2021-12-03",
  duration: "45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 240,
  date: "2021-12-03",
  duration: "11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 241,
  date: "2021-12-06",
  duration: "6h 11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.9
}, {
  tradeNumber: 242,
  date: "2021-12-06",
  duration: "1m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 243,
  date: "2021-12-06",
  duration: "1h 16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.8
}, {
  tradeNumber: 244,
  date: "2021-12-07",
  duration: "21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 245,
  date: "2021-12-08",
  duration: "2h 58m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.36
}, {
  tradeNumber: 246,
  date: "2021-12-08",
  duration: "6h 20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 247,
  date: "2021-12-09",
  duration: "13h 57m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.51
}, {
  tradeNumber: 248,
  date: "2021-12-09",
  duration: "54m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.0
}, {
  tradeNumber: 249,
  date: "2021-12-10",
  duration: "0m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.0
}, {
  tradeNumber: 250,
  date: "2021-12-13",
  duration: "26h 05m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 12.9
}, {
  tradeNumber: 251,
  date: "2021-12-13",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 6.28
}, {
  tradeNumber: 252,
  date: "2021-12-14",
  duration: "23m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 253,
  date: "2021-12-15",
  duration: "2h 05m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.32
}, {
  tradeNumber: 254,
  date: "2021-12-15",
  duration: "49m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 255,
  date: "2021-12-16",
  duration: "6h 28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 11.2
}, {
  tradeNumber: 256,
  date: "2021-12-17",
  duration: "5h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 257,
  date: "2021-12-19",
  duration: "2h 11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 258,
  date: "2021-12-20",
  duration: "1h 27m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.99
}, {
  tradeNumber: 259,
  date: "2021-12-21",
  duration: "4h 41m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.15
}, {
  tradeNumber: 260,
  date: "2021-12-21",
  duration: "2h 43m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.0
}, {
  tradeNumber: 261,
  date: "2021-12-22",
  duration: "3h 35m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 262,
  date: "2021-12-22",
  duration: "6h 28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.8
}, {
  tradeNumber: 263,
  date: "2021-12-23",
  duration: "4h 07m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 264,
  date: "2021-12-27",
  duration: "88h 53m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.34
}, {
  tradeNumber: 265,
  date: "2021-12-27",
  duration: "3m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 266,
  date: "2021-12-28",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.77
}, {
  tradeNumber: 267,
  date: "2021-12-30",
  duration: "37m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 268,
  date: "2021-12-31",
  duration: "57h 23m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.22
}, {
  tradeNumber: 269,
  date: "2021-12-31",
  duration: "6h 12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.37
}, {
  tradeNumber: 270,
  date: "2022-01-03",
  duration: "10h 45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 271,
  date: "2022-01-03",
  duration: "49m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 272,
  date: "2022-01-03",
  duration: "58m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 273,
  date: "2022-01-03",
  duration: "14h 39m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 274,
  date: "2022-01-04",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 4.07
}, {
  tradeNumber: 275,
  date: "2022-01-05",
  duration: "9h 30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 276,
  date: "2022-01-05",
  duration: "31m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 277,
  date: "2022-01-05",
  duration: "3h 27m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 6.0
}, {
  tradeNumber: 278,
  date: "2022-01-06",
  duration: "55m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 279,
  date: "2022-01-06",
  duration: "6m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 280,
  date: "2022-01-06",
  duration: "1h 54m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.78
}, {
  tradeNumber: 281,
  date: "2022-01-07",
  duration: "5h 13m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 282,
  date: "2022-01-07",
  duration: "3m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 283,
  date: "2022-01-09",
  duration: "9h 03m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.76
}, {
  tradeNumber: 284,
  date: "2022-01-10",
  duration: "0m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.0
}, {
  tradeNumber: 285,
  date: "2022-01-10",
  duration: "3h 40m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 286,
  date: "2022-01-11",
  duration: "1h 38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 287,
  date: "2022-01-11",
  duration: "28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 288,
  date: "2022-01-11",
  duration: "33m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 289,
  date: "2022-01-12",
  duration: "8h 18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 290,
  date: "2022-01-12",
  duration: "22m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 291,
  date: "2022-01-13",
  duration: "31m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.02
}, {
  tradeNumber: 292,
  date: "2022-01-14",
  duration: "19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 293,
  date: "2022-01-14",
  duration: "1h 26m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 294,
  date: "2022-01-14",
  duration: "3h 57m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.83
}, {
  tradeNumber: 295,
  date: "2022-01-18",
  duration: "10m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 296,
  date: "2022-01-18",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 297,
  date: "2022-01-18",
  duration: "36m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 298,
  date: "2022-01-18",
  duration: "1h 01m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.13
}, {
  tradeNumber: 299,
  date: "2022-01-19",
  duration: "7m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 300,
  date: "2022-01-20",
  duration: "3h 38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 301,
  date: "2022-01-20",
  duration: "4h 31m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 302,
  date: "2022-01-21",
  duration: "12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.74
}, {
  tradeNumber: 303,
  date: "2022-01-21",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 304,
  date: "2022-01-24",
  duration: "1m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 305,
  date: "2022-01-25",
  duration: "1h 33m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.54
}, {
  tradeNumber: 306,
  date: "2022-01-25",
  duration: "1h 17m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.45
}, {
  tradeNumber: 307,
  date: "2022-01-26",
  duration: "13m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 308,
  date: "2022-01-27",
  duration: "6h 33m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.46
}, {
  tradeNumber: 309,
  date: "2022-01-28",
  duration: "1h 27m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 310,
  date: "2022-01-28",
  duration: "3m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 311,
  date: "2022-01-31",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 8.67
}, {
  tradeNumber: 312,
  date: "2022-01-31",
  duration: "22m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 313,
  date: "2022-02-01",
  duration: "8h 14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.04
}, {
  tradeNumber: 314,
  date: "2022-02-01",
  duration: "5h 48m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 315,
  date: "2022-02-02",
  duration: "1h 39m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 316,
  date: "2022-02-02",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.36
}, {
  tradeNumber: 317,
  date: "2022-02-02",
  duration: "1h 17m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.84
}, {
  tradeNumber: 318,
  date: "2022-02-03",
  duration: "7m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 319,
  date: "2022-02-04",
  duration: "13h 07m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.84
}, {
  tradeNumber: 320,
  date: "2022-02-04",
  duration: "6m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 321,
  date: "2022-02-07",
  duration: "21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 322,
  date: "2022-02-07",
  duration: "3h 54m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.87
}, {
  tradeNumber: 323,
  date: "2022-02-08",
  duration: "1h 17m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 324,
  date: "2022-02-09",
  duration: "1h 53m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 325,
  date: "2022-02-09",
  duration: "4h 59m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.96
}, {
  tradeNumber: 326,
  date: "2022-02-10",
  duration: "1h 48m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.27
}, {
  tradeNumber: 327,
  date: "2022-02-10",
  duration: "1h 38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.2
}, {
  tradeNumber: 328,
  date: "2022-02-11",
  duration: "1h 47m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 329,
  date: "2022-02-11",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 330,
  date: "2022-02-14",
  duration: "37m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 331,
  date: "2022-02-14",
  duration: "4h 25m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 332,
  date: "2022-02-14",
  duration: "4h 39m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.68
}, {
  tradeNumber: 333,
  date: "2022-02-15",
  duration: "18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 334,
  date: "2022-02-16",
  duration: "4h 42m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 335,
  date: "2022-02-17",
  duration: "1h 07m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 336,
  date: "2022-02-18",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 337,
  date: "2022-02-20",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 338,
  date: "2022-02-21",
  duration: "4h 14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 339,
  date: "2022-02-22",
  duration: "12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 340,
  date: "2022-02-22",
  duration: "11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 341,
  date: "2022-02-23",
  duration: "13h 32m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 5.93
}, {
  tradeNumber: 342,
  date: "2022-02-23",
  duration: "6h 28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 6.32
}, {
  tradeNumber: 343,
  date: "2022-02-24",
  duration: "2h 04m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.66
}, {
  tradeNumber: 344,
  date: "2022-02-24",
  duration: "1m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 345,
  date: "2022-02-24",
  duration: "37m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 346,
  date: "2022-02-25",
  duration: "4h 58m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.64
}, {
  tradeNumber: 347,
  date: "2022-02-25",
  duration: "32m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 348,
  date: "2022-02-25",
  duration: "1h 17m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 349,
  date: "2022-02-27",
  duration: "1h 03m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.5
}, {
  tradeNumber: 350,
  date: "2022-02-28",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.2
}, {
  tradeNumber: 351,
  date: "2022-03-01",
  duration: "6h 31m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.79
}, {
  tradeNumber: 352,
  date: "2022-03-01",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 353,
  date: "2022-03-02",
  duration: "39m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 354,
  date: "2022-03-02",
  duration: "46m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.79
}, {
  tradeNumber: 355,
  date: "2022-03-03",
  duration: "24m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 356,
  date: "2022-03-04",
  duration: "17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 357,
  date: "2022-03-06",
  duration: "23m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 358,
  date: "2022-03-07",
  duration: "7h 14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.79
}, {
  tradeNumber: 359,
  date: "2022-03-07",
  duration: "12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 360,
  date: "2022-03-08",
  duration: "4h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.71
}, {
  tradeNumber: 361,
  date: "2022-03-08",
  duration: "22m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 362,
  date: "2022-03-10",
  duration: "1h 03m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 363,
  date: "2022-03-10",
  duration: "8h 05m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 364,
  date: "2022-03-11",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 8.23
}, {
  tradeNumber: 365,
  date: "2022-03-14",
  duration: "4h 14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 366,
  date: "2022-03-14",
  duration: "18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 367,
  date: "2022-03-14",
  duration: "4h 16m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.66
}, {
  tradeNumber: 368,
  date: "2022-03-15",
  duration: "38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 369,
  date: "2022-03-15",
  duration: "16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 370,
  date: "2022-03-16",
  duration: "21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 371,
  date: "2022-03-16",
  duration: "9m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 372,
  date: "2022-03-16",
  duration: "31m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 373,
  date: "2022-03-17",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.7
}, {
  tradeNumber: 374,
  date: "2022-03-17",
  duration: "54m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.79
}, {
  tradeNumber: 375,
  date: "2022-03-18",
  duration: "98h 31m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 8.4
}, {
  tradeNumber: 376,
  date: "2022-03-18",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 8.25
}, {
  tradeNumber: 377,
  date: "2022-03-21",
  duration: "12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 378,
  date: "2022-03-22",
  duration: "5h 59m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.99
}, {
  tradeNumber: 379,
  date: "2022-03-22",
  duration: "19h 22m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.04
}, {
  tradeNumber: 380,
  date: "2022-03-23",
  duration: "34m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 381,
  date: "2022-03-23",
  duration: "51m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 382,
  date: "2022-03-24",
  duration: "1h 31m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.0
}, {
  tradeNumber: 383,
  date: "2022-03-24",
  duration: "100h 30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 8.92
}, {
  tradeNumber: 384,
  date: "2022-03-25",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.41
}, {
  tradeNumber: 385,
  date: "2022-03-28",
  duration: "42m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 386,
  date: "2022-03-29",
  duration: "7h 30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 387,
  date: "2022-03-29",
  duration: "1h 11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.3
}, {
  tradeNumber: 388,
  date: "2022-03-30",
  duration: "1h 41m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 389,
  date: "2022-03-31",
  duration: "7h 33m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.71
}, {
  tradeNumber: 390,
  date: "2022-03-31",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 5.06
}, {
  tradeNumber: 391,
  date: "2022-04-01",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.05
}, {
  tradeNumber: 392,
  date: "2022-04-04",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 3.15
}, {
  tradeNumber: 393,
  date: "2022-04-05",
  duration: "27h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 14.24
}, {
  tradeNumber: 394,
  date: "2022-04-06",
  duration: "4h 21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 395,
  date: "2022-04-07",
  duration: "3h 21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 396,
  date: "2022-04-07",
  duration: "1h 06m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 397,
  date: "2022-04-08",
  duration: "75h 59m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 8.4
}, {
  tradeNumber: 398,
  date: "2022-04-08",
  duration: "1h 32m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 399,
  date: "2022-04-11",
  duration: "1h 55m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 400,
  date: "2022-04-12",
  duration: "39m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 401,
  date: "2022-04-12",
  duration: "16h 31m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.74
}, {
  tradeNumber: 402,
  date: "2022-04-13",
  duration: "6h 17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 3.41
}, {
  tradeNumber: 403,
  date: "2022-04-14",
  duration: "91h 34m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 8.87
}, {
  tradeNumber: 404,
  date: "2022-04-14",
  duration: "3m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 405,
  date: "2022-04-18",
  duration: "12h 03m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.96
}, {
  tradeNumber: 406,
  date: "2022-04-19",
  duration: "4m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 407,
  date: "2022-04-19",
  duration: "14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 408,
  date: "2022-04-19",
  duration: "8h 48m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.95
}, {
  tradeNumber: 409,
  date: "2022-04-20",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 6.74
}, {
  tradeNumber: 410,
  date: "2022-04-20",
  duration: "1h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.95
}, {
  tradeNumber: 411,
  date: "2022-04-21",
  duration: "5h 52m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 6.83
}, {
  tradeNumber: 412,
  date: "2022-04-22",
  duration: "1h 34m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.07
}, {
  tradeNumber: 413,
  date: "2022-04-22",
  duration: "21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 414,
  date: "2022-04-25",
  duration: "2h 14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.91
}, {
  tradeNumber: 415,
  date: "2022-04-25",
  duration: "50m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 416,
  date: "2022-04-26",
  duration: "17h 56m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 5.84
}, {
  tradeNumber: 417,
  date: "2022-04-26",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 4.56
}, {
  tradeNumber: 418,
  date: "2022-04-27",
  duration: "31m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 419,
  date: "2022-04-27",
  duration: "1h 18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.69
}, {
  tradeNumber: 420,
  date: "2022-04-28",
  duration: "8h 03m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.81
}, {
  tradeNumber: 421,
  date: "2022-04-28",
  duration: "2h 45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 422,
  date: "2022-04-29",
  duration: "1h 01m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.8
}, {
  tradeNumber: 423,
  date: "2022-04-29",
  duration: "56m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 424,
  date: "2022-05-02",
  duration: "6m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 425,
  date: "2022-05-02",
  duration: "37m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.67
}, {
  tradeNumber: 426,
  date: "2022-05-02",
  duration: "7h 04m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 427,
  date: "2022-05-03",
  duration: "29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.0
}, {
  tradeNumber: 428,
  date: "2022-05-04",
  duration: "6h 22m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 429,
  date: "2022-05-04",
  duration: "2m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 430,
  date: "2022-05-05",
  duration: "9h 21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 7.41
}, {
  tradeNumber: 431,
  date: "2022-05-05",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 5.59
}, {
  tradeNumber: 432,
  date: "2022-05-06",
  duration: "5h 31m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 433,
  date: "2022-05-09",
  duration: "9h 37m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 434,
  date: "2022-05-10",
  duration: "14h 51m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.7
}, {
  tradeNumber: 435,
  date: "2022-05-10",
  duration: "6m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 436,
  date: "2022-05-11",
  duration: "9m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.59
}, {
  tradeNumber: 437,
  date: "2022-05-11",
  duration: "2h 41m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.99
}, {
  tradeNumber: 438,
  date: "2022-05-12",
  duration: "2h 33m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.59
}, {
  tradeNumber: 439,
  date: "2022-05-12",
  duration: "3h 24m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 440,
  date: "2022-05-12",
  duration: "3m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 441,
  date: "2022-05-12",
  duration: "8h 44m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.55
}, {
  tradeNumber: 442,
  date: "2022-05-13",
  duration: "10h 35m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 443,
  date: "2022-05-13",
  duration: "20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 444,
  date: "2022-05-16",
  duration: "2h 36m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.84
}, {
  tradeNumber: 445,
  date: "2022-05-16",
  duration: "5h 02m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 446,
  date: "2022-05-16",
  duration: "14h 38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 447,
  date: "2022-05-17",
  duration: "41m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.0
}, {
  tradeNumber: 448,
  date: "2022-05-18",
  duration: "4h 07m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 449,
  date: "2022-05-18",
  duration: "6h 18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 4.21
}, {
  tradeNumber: 450,
  date: "2022-05-19",
  duration: "11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 451,
  date: "2022-05-19",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.12
}, {
  tradeNumber: 452,
  date: "2022-05-19",
  duration: "19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.83
}, {
  tradeNumber: 453,
  date: "2022-05-19",
  duration: "5h 13m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.63
}, {
  tradeNumber: 454,
  date: "2022-05-20",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.19
}, {
  tradeNumber: 455,
  date: "2022-05-23",
  duration: "3h 45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.83
}, {
  tradeNumber: 456,
  date: "2022-05-23",
  duration: "32m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 457,
  date: "2022-05-23",
  duration: "18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 458,
  date: "2022-05-23",
  duration: "30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 459,
  date: "2022-05-24",
  duration: "8h 28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 460,
  date: "2022-05-24",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.1
}, {
  tradeNumber: 461,
  date: "2022-05-25",
  duration: "4h 10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 462,
  date: "2022-05-26",
  duration: "2h 36m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 463,
  date: "2022-05-26",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 464,
  date: "2022-05-27",
  duration: "4h 13m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 465,
  date: "2022-05-27",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.15
}, {
  tradeNumber: 466,
  date: "2022-05-30",
  duration: "3h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.65
}, {
  tradeNumber: 467,
  date: "2022-05-31",
  duration: "3m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 468,
  date: "2022-06-01",
  duration: "19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 469,
  date: "2022-06-01",
  duration: "38m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 470,
  date: "2022-06-01",
  duration: "18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 471,
  date: "2022-06-02",
  duration: "1h 23m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 472,
  date: "2022-06-02",
  duration: "25m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 473,
  date: "2022-06-02",
  duration: "19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 474,
  date: "2022-06-06",
  duration: "1h 54m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 475,
  date: "2022-06-06",
  duration: "18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 476,
  date: "2022-06-07",
  duration: "4h 52m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 477,
  date: "2022-06-07",
  duration: "2h 04m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 478,
  date: "2022-06-07",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 5.88
}, {
  tradeNumber: 479,
  date: "2022-06-07",
  duration: "43m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 480,
  date: "2022-06-08",
  duration: "1h 42m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.36
}, {
  tradeNumber: 481,
  date: "2022-06-08",
  duration: "3h 09m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 482,
  date: "2022-06-09",
  duration: "9h 51m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.27
}, {
  tradeNumber: 483,
  date: "2022-06-09",
  duration: "6m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 484,
  date: "2022-06-09",
  duration: "7m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 485,
  date: "2022-06-10",
  duration: "5h 16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 486,
  date: "2022-06-10",
  duration: "6h 07m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.95
}, {
  tradeNumber: 487,
  date: "2022-06-10",
  duration: "50h 01m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 488,
  date: "2022-06-13",
  duration: "36m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 489,
  date: "2022-06-13",
  duration: "5h 49m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.29
}, {
  tradeNumber: 490,
  date: "2022-06-13",
  duration: "13h 43m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.75
}, {
  tradeNumber: 491,
  date: "2022-06-14",
  duration: "23m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 492,
  date: "2022-06-14",
  duration: "3h 07m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.82
}, {
  tradeNumber: 493,
  date: "2022-06-15",
  duration: "4h 42m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 494,
  date: "2022-06-16",
  duration: "1h 04m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 495,
  date: "2022-06-16",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.48
}, {
  tradeNumber: 496,
  date: "2022-06-16",
  duration: "1h 02m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 497,
  date: "2022-06-17",
  duration: "54m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.94
}, {
  tradeNumber: 498,
  date: "2022-06-17",
  duration: "34m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 499,
  date: "2022-06-20",
  duration: "3h 15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 500,
  date: "2022-06-20",
  duration: "4h 05m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 501,
  date: "2022-06-21",
  duration: "6h 02m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 502,
  date: "2022-06-21",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.03
}, {
  tradeNumber: 503,
  date: "2022-06-22",
  duration: "6h 28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.4
}, {
  tradeNumber: 504,
  date: "2022-06-23",
  duration: "6h 01m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.02
}, {
  tradeNumber: 505,
  date: "2022-06-23",
  duration: "4m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 506,
  date: "2022-06-23",
  duration: "7h 00m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 507,
  date: "2022-06-24",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 508,
  date: "2022-06-24",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 7.75
}, {
  tradeNumber: 509,
  date: "2022-06-27",
  duration: "5h 02m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 510,
  date: "2022-06-27",
  duration: "4m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 511,
  date: "2022-06-27",
  duration: "12h 24m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.0
}, {
  tradeNumber: 512,
  date: "2022-06-28",
  duration: "6h 04m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 513,
  date: "2022-06-28",
  duration: "2m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 514,
  date: "2022-06-28",
  duration: "52m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 515,
  date: "2022-06-29",
  duration: "42m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.05
}, {
  tradeNumber: 516,
  date: "2022-06-29",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 517,
  date: "2022-06-30",
  duration: "6m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 518,
  date: "2022-07-05",
  duration: "3h 02m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 519,
  date: "2022-07-06",
  duration: "1h 33m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.08
}, {
  tradeNumber: 520,
  date: "2022-07-06",
  duration: "7m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 521,
  date: "2022-07-06",
  duration: "4h 30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 522,
  date: "2022-07-07",
  duration: "48m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 523,
  date: "2022-07-07",
  duration: "6h 17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.36
}, {
  tradeNumber: 524,
  date: "2022-07-08",
  duration: "9m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 525,
  date: "2022-07-08",
  duration: "52m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 526,
  date: "2022-07-11",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.2
}, {
  tradeNumber: 527,
  date: "2022-07-11",
  duration: "5h 37m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 528,
  date: "2022-07-12",
  duration: "25m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 529,
  date: "2022-07-13",
  duration: "23m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 530,
  date: "2022-07-13",
  duration: "0m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.0
}, {
  tradeNumber: 531,
  date: "2022-07-13",
  duration: "1h 01m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 532,
  date: "2022-07-14",
  duration: "21m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 533,
  date: "2022-07-14",
  duration: "4m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 534,
  date: "2022-07-15",
  duration: "103h 16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 8.09
}, {
  tradeNumber: 535,
  date: "2022-07-15",
  duration: "20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 536,
  date: "2022-07-15",
  duration: "0m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.0
}, {
  tradeNumber: 537,
  date: "2022-07-18",
  duration: "19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 538,
  date: "2022-07-18",
  duration: "2h 26m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.2
}, {
  tradeNumber: 539,
  date: "2022-07-19",
  duration: "12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 540,
  date: "2022-07-20",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 5.46
}, {
  tradeNumber: 541,
  date: "2022-07-20",
  duration: "9m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 542,
  date: "2022-07-21",
  duration: "30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 543,
  date: "2022-07-21",
  duration: "29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.18
}, {
  tradeNumber: 544,
  date: "2022-07-21",
  duration: "4m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 545,
  date: "2022-07-22",
  duration: "8h 45m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.4
}, {
  tradeNumber: 546,
  date: "2022-07-22",
  duration: "23m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 547,
  date: "2022-07-25",
  duration: "1h 21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 548,
  date: "2022-07-25",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.13
}, {
  tradeNumber: 549,
  date: "2022-07-25",
  duration: "40m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 550,
  date: "2022-07-25",
  duration: "18h 33m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 551,
  date: "2022-07-26",
  duration: "6h 14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.86
}, {
  tradeNumber: 552,
  date: "2022-07-27",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 9.9
}, {
  tradeNumber: 553,
  date: "2022-07-27",
  duration: "8m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 554,
  date: "2022-07-29",
  duration: "12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 555,
  date: "2022-08-01",
  duration: "2h 39m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 556,
  date: "2022-08-01",
  duration: "10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 557,
  date: "2022-08-02",
  duration: "7h 31m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 558,
  date: "2022-08-02",
  duration: "40m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 559,
  date: "2022-08-02",
  duration: "3h 36m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.18
}, {
  tradeNumber: 560,
  date: "2022-08-03",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.97
}, {
  tradeNumber: 561,
  date: "2022-08-03",
  duration: "11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 562,
  date: "2022-08-04",
  duration: "14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 563,
  date: "2022-08-04",
  duration: "55m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 564,
  date: "2022-08-05",
  duration: "12h 14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.45
}, {
  tradeNumber: 565,
  date: "2022-08-05",
  duration: "50m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 566,
  date: "2022-08-08",
  duration: "3m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 567,
  date: "2022-08-09",
  duration: "6h 06m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.08
}, {
  tradeNumber: 568,
  date: "2022-08-10",
  duration: "6m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 569,
  date: "2022-08-10",
  duration: "1h 09m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 570,
  date: "2022-08-11",
  duration: "55m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 571,
  date: "2022-08-12",
  duration: "1h 06m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 572,
  date: "2022-08-12",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.73
}, {
  tradeNumber: 573,
  date: "2022-08-15",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 3.77
}, {
  tradeNumber: 574,
  date: "2022-08-15",
  duration: "23m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 575,
  date: "2022-08-16",
  duration: "6h 37m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 576,
  date: "2022-08-16",
  duration: "2h 26m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.0
}, {
  tradeNumber: 577,
  date: "2022-08-17",
  duration: "4h 23m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 578,
  date: "2022-08-18",
  duration: "1h 45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 579,
  date: "2022-08-18",
  duration: "84h 57m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 8.92
}, {
  tradeNumber: 580,
  date: "2022-08-19",
  duration: "10m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 581,
  date: "2022-08-22",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 582,
  date: "2022-08-22",
  duration: "6h 10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.04
}, {
  tradeNumber: 583,
  date: "2022-08-23",
  duration: "6h 03m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 584,
  date: "2022-08-23",
  duration: "4m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 585,
  date: "2022-08-24",
  duration: "26m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 586,
  date: "2022-08-25",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 587,
  date: "2022-08-25",
  duration: "5h 30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 588,
  date: "2022-08-26",
  duration: "40m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 589,
  date: "2022-08-26",
  duration: "11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 590,
  date: "2022-08-29",
  duration: "1h 06m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.0
}, {
  tradeNumber: 591,
  date: "2022-08-29",
  duration: "10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 592,
  date: "2022-08-30",
  duration: "54h 25m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 9.14
}, {
  tradeNumber: 593,
  date: "2022-08-30",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.35
}, {
  tradeNumber: 594,
  date: "2022-08-31",
  duration: "13m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 595,
  date: "2022-09-02",
  duration: "5h 11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.24
}, {
  tradeNumber: 596,
  date: "2022-09-02",
  duration: "25m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 597,
  date: "2022-09-05",
  duration: "3h 24m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.06
}, {
  tradeNumber: 598,
  date: "2022-09-05",
  duration: "10h 53m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 599,
  date: "2022-09-06",
  duration: "32h 34m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.37
}, {
  tradeNumber: 600,
  date: "2022-09-06",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.93
}, {
  tradeNumber: 601,
  date: "2022-09-07",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 6.81
}, {
  tradeNumber: 602,
  date: "2022-09-08",
  duration: "8h 25m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.58
}, {
  tradeNumber: 603,
  date: "2022-09-08",
  duration: "31m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 604,
  date: "2022-09-12",
  duration: "5h 10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 605,
  date: "2022-09-12",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.93
}, {
  tradeNumber: 606,
  date: "2022-09-13",
  duration: "6h 24m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 5.79
}, {
  tradeNumber: 607,
  date: "2022-09-14",
  duration: "1h 32m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 608,
  date: "2022-09-14",
  duration: "5h 40m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.14
}, {
  tradeNumber: 609,
  date: "2022-09-14",
  duration: "3m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 610,
  date: "2022-09-14",
  duration: "15h 22m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.92
}, {
  tradeNumber: 611,
  date: "2022-09-15",
  duration: "19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 612,
  date: "2022-09-15",
  duration: "3h 25m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.03
}, {
  tradeNumber: 613,
  date: "2022-09-16",
  duration: "1h 04m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 614,
  date: "2022-09-16",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 615,
  date: "2022-09-19",
  duration: "4h 47m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 616,
  date: "2022-09-20",
  duration: "8h 44m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.53
}, {
  tradeNumber: 617,
  date: "2022-09-20",
  duration: "1h 10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 618,
  date: "2022-09-22",
  duration: "6h 21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.2
}, {
  tradeNumber: 619,
  date: "2022-09-22",
  duration: "4h 55m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.85
}, {
  tradeNumber: 620,
  date: "2022-09-26",
  duration: "2h 32m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.13
}, {
  tradeNumber: 621,
  date: "2022-09-26",
  duration: "27m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 622,
  date: "2022-09-26",
  duration: "1h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 623,
  date: "2022-09-27",
  duration: "27h 34m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.16
}, {
  tradeNumber: 624,
  date: "2022-09-27",
  duration: "5h 59m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.15
}, {
  tradeNumber: 625,
  date: "2022-09-28",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 626,
  date: "2022-09-29",
  duration: "1h 09m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 627,
  date: "2022-09-29",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.58
}, {
  tradeNumber: 628,
  date: "2022-09-30",
  duration: "3h 12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.01
}, {
  tradeNumber: 629,
  date: "2022-09-30",
  duration: "4m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 630,
  date: "2022-09-30",
  duration: "1h 16m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.8
}, {
  tradeNumber: 631,
  date: "2022-10-03",
  duration: "1h 36m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 632,
  date: "2022-10-03",
  duration: "6m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 633,
  date: "2022-10-04",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 634,
  date: "2022-10-04",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.19
}, {
  tradeNumber: 635,
  date: "2022-10-04",
  duration: "14h 58m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.12
}, {
  tradeNumber: 636,
  date: "2022-10-05",
  duration: "3h 07m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 637,
  date: "2022-10-05",
  duration: "17h 14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.03
}, {
  tradeNumber: 638,
  date: "2022-10-06",
  duration: "58m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 639,
  date: "2022-10-06",
  duration: "7h 49m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 640,
  date: "2022-10-07",
  duration: "11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.12
}, {
  tradeNumber: 641,
  date: "2022-10-07",
  duration: "9m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 642,
  date: "2022-10-07",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.56
}, {
  tradeNumber: 643,
  date: "2022-10-10",
  duration: "6h 06m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.61
}, {
  tradeNumber: 644,
  date: "2022-10-10",
  duration: "57m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 645,
  date: "2022-10-11",
  duration: "2h 07m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 646,
  date: "2022-10-11",
  duration: "16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 647,
  date: "2022-10-11",
  duration: "6h 23m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.83
}, {
  tradeNumber: 648,
  date: "2022-10-12",
  duration: "7m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 649,
  date: "2022-10-13",
  duration: "5h 28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.5
}, {
  tradeNumber: 650,
  date: "2022-10-13",
  duration: "16m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 651,
  date: "2022-10-14",
  duration: "8h 21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.73
}, {
  tradeNumber: 652,
  date: "2022-10-14",
  duration: "72h 58m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.71
}, {
  tradeNumber: 653,
  date: "2022-10-17",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.7
}, {
  tradeNumber: 654,
  date: "2022-10-18",
  duration: "1h 07m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 655,
  date: "2022-10-18",
  duration: "15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 656,
  date: "2022-10-18",
  duration: "37m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 657,
  date: "2022-10-19",
  duration: "2h 57m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.66
}, {
  tradeNumber: 658,
  date: "2022-10-20",
  duration: "12h 00m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.9
}, {
  tradeNumber: 659,
  date: "2022-10-20",
  duration: "4m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 660,
  date: "2022-10-20",
  duration: "6h 21m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 661,
  date: "2022-10-21",
  duration: "5h 30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.11
}, {
  tradeNumber: 662,
  date: "2022-10-21",
  duration: "46m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 663,
  date: "2022-10-21",
  duration: "6h 14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 3.64
}, {
  tradeNumber: 664,
  date: "2022-10-24",
  duration: "2h 31m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 665,
  date: "2022-10-24",
  duration: "1h 09m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.85
}, {
  tradeNumber: 666,
  date: "2022-10-25",
  duration: "31m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 667,
  date: "2022-10-25",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.74
}, {
  tradeNumber: 668,
  date: "2022-10-26",
  duration: "8h 25m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.06
}, {
  tradeNumber: 669,
  date: "2022-10-26",
  duration: "30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 670,
  date: "2022-10-26",
  duration: "3h 30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.3
}, {
  tradeNumber: 671,
  date: "2022-10-27",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.35
}, {
  tradeNumber: 672,
  date: "2022-10-28",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 9.49
}, {
  tradeNumber: 673,
  date: "2022-10-28",
  duration: "2h 21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 674,
  date: "2022-10-31",
  duration: "17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 675,
  date: "2022-11-01",
  duration: "49m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 676,
  date: "2022-11-02",
  duration: "49m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 677,
  date: "2022-11-02",
  duration: "3h 46m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 678,
  date: "2022-11-03",
  duration: "2h 18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 679,
  date: "2022-11-03",
  duration: "12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 680,
  date: "2022-11-04",
  duration: "3m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 681,
  date: "2022-11-07",
  duration: "14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 682,
  date: "2022-11-08",
  duration: "18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 683,
  date: "2022-11-08",
  duration: "14h 25m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.97
}, {
  tradeNumber: 684,
  date: "2022-11-09",
  duration: "46m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 685,
  date: "2022-11-10",
  duration: "10m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 686,
  date: "2022-11-11",
  duration: "2h 16m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 687,
  date: "2022-11-11",
  duration: "1h 51m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.09
}, {
  tradeNumber: 688,
  date: "2022-11-11",
  duration: "20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 689,
  date: "2022-11-14",
  duration: "2h 16m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 690,
  date: "2022-11-14",
  duration: "5h 41m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.39
}, {
  tradeNumber: 691,
  date: "2022-11-15",
  duration: "6h 18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.49
}, {
  tradeNumber: 692,
  date: "2022-11-16",
  duration: "50m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 693,
  date: "2022-11-17",
  duration: "12h 01m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 694,
  date: "2022-11-21",
  duration: "1h 46m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 695,
  date: "2022-11-21",
  duration: "5h 53m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.64
}, {
  tradeNumber: 696,
  date: "2022-11-22",
  duration: "154h 47m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.97
}, {
  tradeNumber: 697,
  date: "2022-11-22",
  duration: "1h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 698,
  date: "2022-11-23",
  duration: "3h 12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 699,
  date: "2022-11-24",
  duration: "3h 07m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.17
}, {
  tradeNumber: 700,
  date: "2022-11-25",
  duration: "3h 43m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.06
}, {
  tradeNumber: 701,
  date: "2022-11-28",
  duration: "40m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 702,
  date: "2022-11-29",
  duration: "31m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 703,
  date: "2022-11-29",
  duration: "6h 15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.28
}, {
  tradeNumber: 704,
  date: "2022-11-30",
  duration: "5h 11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 705,
  date: "2022-12-01",
  duration: "6h 41m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 706,
  date: "2022-12-01",
  duration: "14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 707,
  date: "2022-12-02",
  duration: "5h 47m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.24
}, {
  tradeNumber: 708,
  date: "2022-12-05",
  duration: "6m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 709,
  date: "2022-12-06",
  duration: "166h 22m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.99
}, {
  tradeNumber: 710,
  date: "2022-12-06",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 9.93
}, {
  tradeNumber: 711,
  date: "2022-12-08",
  duration: "7m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 712,
  date: "2022-12-09",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 713,
  date: "2022-12-12",
  duration: "20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 714,
  date: "2022-12-14",
  duration: "15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 715,
  date: "2022-12-14",
  duration: "0m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.0
}, {
  tradeNumber: 716,
  date: "2022-12-14",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 717,
  date: "2022-12-15",
  duration: "48m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 718,
  date: "2022-12-15",
  duration: "1h 15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 719,
  date: "2022-12-15",
  duration: "6h 13m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.09
}, {
  tradeNumber: 720,
  date: "2022-12-16",
  duration: "18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 721,
  date: "2022-12-16",
  duration: "145h 49m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 9.08
}, {
  tradeNumber: 722,
  date: "2022-12-19",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 4.56
}, {
  tradeNumber: 723,
  date: "2022-12-20",
  duration: "28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 724,
  date: "2022-12-21",
  duration: "18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 725,
  date: "2022-12-22",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.1
}, {
  tradeNumber: 726,
  date: "2022-12-23",
  duration: "9h 57m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 727,
  date: "2022-12-23",
  duration: "33m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 728,
  date: "2022-12-23",
  duration: "3m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 729,
  date: "2022-12-23",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 730,
  date: "2022-12-27",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.3
}, {
  tradeNumber: 731,
  date: "2022-12-27",
  duration: "23h 46m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 732,
  date: "2022-12-28",
  duration: "3m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 733,
  date: "2022-12-28",
  duration: "3h 37m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.62
}, {
  tradeNumber: 734,
  date: "2022-12-30",
  duration: "1h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 735,
  date: "2023-01-03",
  duration: "14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 736,
  date: "2023-01-03",
  duration: "76h 31m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.12
}, {
  tradeNumber: 737,
  date: "2023-01-05",
  duration: "37m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 738,
  date: "2023-01-06",
  duration: "18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 739,
  date: "2023-01-09",
  duration: "5h 48m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 740,
  date: "2023-01-10",
  duration: "3h 20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.63
}, {
  tradeNumber: 741,
  date: "2023-01-10",
  duration: "1h 02m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 742,
  date: "2023-01-10",
  duration: "14h 56m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 743,
  date: "2023-01-11",
  duration: "6h 16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.38
}, {
  tradeNumber: 744,
  date: "2023-01-12",
  duration: "53m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 745,
  date: "2023-01-13",
  duration: "48m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 746,
  date: "2023-01-13",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 6.38
}, {
  tradeNumber: 747,
  date: "2023-01-17",
  duration: "33m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 748,
  date: "2023-01-17",
  duration: "8m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 749,
  date: "2023-01-17",
  duration: "13h 59m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.78
}, {
  tradeNumber: 750,
  date: "2023-01-19",
  duration: "15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 751,
  date: "2023-01-20",
  duration: "2h 12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 752,
  date: "2023-01-23",
  duration: "1h 33m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 753,
  date: "2023-01-23",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.35
}, {
  tradeNumber: 754,
  date: "2023-01-24",
  duration: "6h 07m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 755,
  date: "2023-01-24",
  duration: "10h 30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 756,
  date: "2023-01-25",
  duration: "54m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 757,
  date: "2023-01-26",
  duration: "1h 04m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 758,
  date: "2023-01-27",
  duration: "8m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 759,
  date: "2023-01-30",
  duration: "1h 27m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 760,
  date: "2023-01-31",
  duration: "5h 22m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 761,
  date: "2023-02-01",
  duration: "6h 53m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 762,
  date: "2023-02-01",
  duration: "2h 40m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 763,
  date: "2023-02-02",
  duration: "4h 55m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 764,
  date: "2023-02-02",
  duration: "30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 765,
  date: "2023-02-03",
  duration: "5h 55m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.98
}, {
  tradeNumber: 766,
  date: "2023-02-05",
  duration: "10h 59m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 767,
  date: "2023-02-06",
  duration: "35m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 768,
  date: "2023-02-07",
  duration: "3h 34m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.65
}, {
  tradeNumber: 769,
  date: "2023-02-07",
  duration: "1h 37m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 770,
  date: "2023-02-08",
  duration: "6h 26m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.73
}, {
  tradeNumber: 771,
  date: "2023-02-09",
  duration: "6h 18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 4.1
}, {
  tradeNumber: 772,
  date: "2023-02-10",
  duration: "36m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 773,
  date: "2023-02-10",
  duration: "127h 02m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 8.56
}, {
  tradeNumber: 774,
  date: "2023-02-15",
  duration: "12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 775,
  date: "2023-02-16",
  duration: "9h 43m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.8
}, {
  tradeNumber: 776,
  date: "2023-02-17",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.54
}, {
  tradeNumber: 777,
  date: "2023-02-17",
  duration: "1h 47m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 778,
  date: "2023-02-17",
  duration: "293h 44m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 8.8
}, {
  tradeNumber: 779,
  date: "2023-02-20",
  duration: "3h 27m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.67
}, {
  tradeNumber: 780,
  date: "2023-02-21",
  duration: "11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 781,
  date: "2023-02-22",
  duration: "16m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 782,
  date: "2023-02-28",
  duration: "12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 783,
  date: "2023-03-01",
  duration: "5h 54m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.89
}, {
  tradeNumber: 784,
  date: "2023-03-02",
  duration: "91h 23m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 12.25
}, {
  tradeNumber: 785,
  date: "2023-03-02",
  duration: "6h 14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.51
}, {
  tradeNumber: 786,
  date: "2023-03-06",
  duration: "1h 30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 787,
  date: "2023-03-07",
  duration: "59m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 788,
  date: "2023-03-07",
  duration: "19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 789,
  date: "2023-03-08",
  duration: "39h 15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.69
}, {
  tradeNumber: 790,
  date: "2023-03-10",
  duration: "26m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 791,
  date: "2023-03-10",
  duration: "2h 10m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.0
}, {
  tradeNumber: 792,
  date: "2023-03-13",
  duration: "8h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.83
}, {
  tradeNumber: 793,
  date: "2023-03-13",
  duration: "34m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 794,
  date: "2023-03-14",
  duration: "4h 28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 795,
  date: "2023-03-15",
  duration: "13h 38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.13
}, {
  tradeNumber: 796,
  date: "2023-03-15",
  duration: "1h 04m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 797,
  date: "2023-03-17",
  duration: "52m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 798,
  date: "2023-03-17",
  duration: "56h 00m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.17
}, {
  tradeNumber: 799,
  date: "2023-03-20",
  duration: "1h 20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 800,
  date: "2023-03-20",
  duration: "9h 25m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 801,
  date: "2023-03-21",
  duration: "3h 55m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 802,
  date: "2023-03-21",
  duration: "54m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 803,
  date: "2023-03-22",
  duration: "3h 02m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 804,
  date: "2023-03-22",
  duration: "5h 39m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 805,
  date: "2023-03-22",
  duration: "1h 07m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.73
}, {
  tradeNumber: 806,
  date: "2023-03-23",
  duration: "31m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 807,
  date: "2023-03-23",
  duration: "5h 08m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 808,
  date: "2023-03-24",
  duration: "1h 02m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 809,
  date: "2023-03-24",
  duration: "7m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 810,
  date: "2023-03-24",
  duration: "51h 58m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 811,
  date: "2023-03-27",
  duration: "57h 30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.34
}, {
  tradeNumber: 812,
  date: "2023-03-27",
  duration: "5h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.44
}, {
  tradeNumber: 813,
  date: "2023-03-28",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.61
}, {
  tradeNumber: 814,
  date: "2023-03-29",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.29
}, {
  tradeNumber: 815,
  date: "2023-03-30",
  duration: "2h 02m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 816,
  date: "2023-03-30",
  duration: "4h 08m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 817,
  date: "2023-03-31",
  duration: "32m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 818,
  date: "2023-03-31",
  duration: "1h 12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 819,
  date: "2023-03-31",
  duration: "17m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 820,
  date: "2023-04-03",
  duration: "1h 03m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 821,
  date: "2023-04-03",
  duration: "13h 45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 822,
  date: "2023-04-04",
  duration: "29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 823,
  date: "2023-04-04",
  duration: "49m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 824,
  date: "2023-04-05",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.42
}, {
  tradeNumber: 825,
  date: "2023-04-06",
  duration: "4h 26m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 826,
  date: "2023-04-06",
  duration: "12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 827,
  date: "2023-04-07",
  duration: "41m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 828,
  date: "2023-04-09",
  duration: "17h 41m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.54
}, {
  tradeNumber: 829,
  date: "2023-04-10",
  duration: "1h 41m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 830,
  date: "2023-04-10",
  duration: "13h 57m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 831,
  date: "2023-04-11",
  duration: "2h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 832,
  date: "2023-04-12",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 8.4
}, {
  tradeNumber: 833,
  date: "2023-04-12",
  duration: "1h 47m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.46
}, {
  tradeNumber: 834,
  date: "2023-04-12",
  duration: "180h 24m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.17
}, {
  tradeNumber: 835,
  date: "2023-04-13",
  duration: "5h 54m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 3.21
}, {
  tradeNumber: 836,
  date: "2023-04-14",
  duration: "1h 02m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 837,
  date: "2023-04-17",
  duration: "6m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 838,
  date: "2023-04-18",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.86
}, {
  tradeNumber: 839,
  date: "2023-04-20",
  duration: "6h 18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.16
}, {
  tradeNumber: 840,
  date: "2023-04-20",
  duration: "5h 30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 841,
  date: "2023-04-21",
  duration: "4h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 842,
  date: "2023-04-21",
  duration: "15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 843,
  date: "2023-04-24",
  duration: "7m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 844,
  date: "2023-04-24",
  duration: "4h 07m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.16
}, {
  tradeNumber: 845,
  date: "2023-04-25",
  duration: "6h 38m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 846,
  date: "2023-04-26",
  duration: "337h 47m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 13.52
}, {
  tradeNumber: 847,
  date: "2023-04-27",
  duration: "6h 06m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.74
}, {
  tradeNumber: 848,
  date: "2023-04-28",
  duration: "11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 849,
  date: "2023-05-01",
  duration: "1h 35m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 850,
  date: "2023-05-02",
  duration: "33m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 851,
  date: "2023-05-03",
  duration: "22m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 852,
  date: "2023-05-05",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 9.41
}, {
  tradeNumber: 853,
  date: "2023-05-08",
  duration: "2h 12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 854,
  date: "2023-05-09",
  duration: "2h 20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 855,
  date: "2023-05-10",
  duration: "11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 856,
  date: "2023-05-10",
  duration: "46h 59m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.44
}, {
  tradeNumber: 857,
  date: "2023-05-11",
  duration: "36m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 858,
  date: "2023-05-15",
  duration: "3h 28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 859,
  date: "2023-05-16",
  duration: "6h 07m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 860,
  date: "2023-05-16",
  duration: "6h 17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.12
}, {
  tradeNumber: 861,
  date: "2023-05-16",
  duration: "212h 32m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 13.94
}, {
  tradeNumber: 862,
  date: "2023-05-18",
  duration: "6h 18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 5.66
}, {
  tradeNumber: 863,
  date: "2023-05-19",
  duration: "11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 864,
  date: "2023-05-23",
  duration: "2m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 865,
  date: "2023-05-24",
  duration: "4m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 866,
  date: "2023-05-25",
  duration: "11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 867,
  date: "2023-05-26",
  duration: "2h 32m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 868,
  date: "2023-05-26",
  duration: "6m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 869,
  date: "2023-05-29",
  duration: "26h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.02
}, {
  tradeNumber: 870,
  date: "2023-05-29",
  duration: "3h 04m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 871,
  date: "2023-05-30",
  duration: "10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 872,
  date: "2023-05-30",
  duration: "3h 52m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 873,
  date: "2023-05-31",
  duration: "32m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 874,
  date: "2023-05-31",
  duration: "3h 46m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.78
}, {
  tradeNumber: 875,
  date: "2023-06-01",
  duration: "160h 50m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.45
}, {
  tradeNumber: 876,
  date: "2023-06-02",
  duration: "17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 877,
  date: "2023-06-05",
  duration: "5h 04m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 878,
  date: "2023-06-07",
  duration: "5h 56m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 6.56
}, {
  tradeNumber: 879,
  date: "2023-06-08",
  duration: "42m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 880,
  date: "2023-06-08",
  duration: "8m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 881,
  date: "2023-06-09",
  duration: "2h 30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 882,
  date: "2023-06-12",
  duration: "2h 04m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 883,
  date: "2023-06-12",
  duration: "72h 58m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 13.95
}, {
  tradeNumber: 884,
  date: "2023-06-14",
  duration: "35m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 885,
  date: "2023-06-15",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 5.17
}, {
  tradeNumber: 886,
  date: "2023-06-16",
  duration: "243h 35m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 12.58
}, {
  tradeNumber: 887,
  date: "2023-06-16",
  duration: "1m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 888,
  date: "2023-06-19",
  duration: "2h 49m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.06
}, {
  tradeNumber: 889,
  date: "2023-06-20",
  duration: "1m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 890,
  date: "2023-06-22",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 891,
  date: "2023-06-26",
  duration: "8m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 892,
  date: "2023-06-27",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 3.9
}, {
  tradeNumber: 893,
  date: "2023-06-28",
  duration: "3h 09m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 894,
  date: "2023-06-28",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 895,
  date: "2023-06-29",
  duration: "54m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 896,
  date: "2023-06-29",
  duration: "6h 28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.05
}, {
  tradeNumber: 897,
  date: "2023-06-30",
  duration: "6h 28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.78
}, {
  tradeNumber: 898,
  date: "2023-07-03",
  duration: "54h 00m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 899,
  date: "2023-07-03",
  duration: "1h 09m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 900,
  date: "2023-07-04",
  duration: "3h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.02
}, {
  tradeNumber: 901,
  date: "2023-07-05",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.9
}, {
  tradeNumber: 902,
  date: "2023-07-06",
  duration: "46m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 903,
  date: "2023-07-06",
  duration: "2h 12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 904,
  date: "2023-07-07",
  duration: "6h 25m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.83
}, {
  tradeNumber: 905,
  date: "2023-07-07",
  duration: "52h 40m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 906,
  date: "2023-07-10",
  duration: "17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 907,
  date: "2023-07-11",
  duration: "14h 36m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 908,
  date: "2023-07-11",
  duration: "2h 30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 909,
  date: "2023-07-12",
  duration: "8h 01m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 910,
  date: "2023-07-12",
  duration: "2h 09m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 911,
  date: "2023-07-13",
  duration: "59m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 912,
  date: "2023-07-14",
  duration: "1h 11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 913,
  date: "2023-07-14",
  duration: "1h 10m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 914,
  date: "2023-07-14",
  duration: "90h 37m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.62
}, {
  tradeNumber: 915,
  date: "2023-07-17",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.77
}, {
  tradeNumber: 916,
  date: "2023-07-18",
  duration: "4h 18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.3
}, {
  tradeNumber: 917,
  date: "2023-07-19",
  duration: "4m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 918,
  date: "2023-07-19",
  duration: "6m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 919,
  date: "2023-07-20",
  duration: "6h 38m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 920,
  date: "2023-07-20",
  duration: "17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 921,
  date: "2023-07-20",
  duration: "1h 20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 922,
  date: "2023-07-21",
  duration: "66h 45m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 923,
  date: "2023-07-24",
  duration: "17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 924,
  date: "2023-07-25",
  duration: "45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 925,
  date: "2023-07-25",
  duration: "22m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 926,
  date: "2023-07-26",
  duration: "3h 43m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 927,
  date: "2023-07-27",
  duration: "55m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 928,
  date: "2023-07-28",
  duration: "4h 33m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 929,
  date: "2023-07-31",
  duration: "25h 54m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.83
}, {
  tradeNumber: 930,
  date: "2023-07-31",
  duration: "11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 931,
  date: "2023-08-01",
  duration: "44m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 932,
  date: "2023-08-02",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 6.72
}, {
  tradeNumber: 933,
  date: "2023-08-02",
  duration: "33m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 934,
  date: "2023-08-03",
  duration: "5h 40m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.38
}, {
  tradeNumber: 935,
  date: "2023-08-04",
  duration: "6h 38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.38
}, {
  tradeNumber: 936,
  date: "2023-08-04",
  duration: "57m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.15
}, {
  tradeNumber: 937,
  date: "2023-08-04",
  duration: "1h 01m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 938,
  date: "2023-08-07",
  duration: "11h 42m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 939,
  date: "2023-08-07",
  duration: "4h 21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 940,
  date: "2023-08-08",
  duration: "38m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 941,
  date: "2023-08-09",
  duration: "6h 45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 942,
  date: "2023-08-09",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 6.39
}, {
  tradeNumber: 943,
  date: "2023-08-09",
  duration: "21m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 944,
  date: "2023-08-10",
  duration: "15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 945,
  date: "2023-08-10",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 946,
  date: "2023-08-11",
  duration: "19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 947,
  date: "2023-08-14",
  duration: "8h 26m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.44
}, {
  tradeNumber: 948,
  date: "2023-08-14",
  duration: "10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 949,
  date: "2023-08-14",
  duration: "7h 11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 950,
  date: "2023-08-15",
  duration: "15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 951,
  date: "2023-08-15",
  duration: "5h 23m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 952,
  date: "2023-08-16",
  duration: "4h 40m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 953,
  date: "2023-08-16",
  duration: "2h 06m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 954,
  date: "2023-08-17",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.97
}, {
  tradeNumber: 955,
  date: "2023-08-17",
  duration: "3h 57m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 956,
  date: "2023-08-18",
  duration: "3h 36m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 957,
  date: "2023-08-18",
  duration: "18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 958,
  date: "2023-08-21",
  duration: "7h 18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.62
}, {
  tradeNumber: 959,
  date: "2023-08-21",
  duration: "59m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 960,
  date: "2023-08-22",
  duration: "55m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 961,
  date: "2023-08-22",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.51
}, {
  tradeNumber: 962,
  date: "2023-08-23",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.08
}, {
  tradeNumber: 963,
  date: "2023-08-23",
  duration: "26m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 964,
  date: "2023-08-24",
  duration: "5h 24m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 965,
  date: "2023-08-24",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 18.43
}, {
  tradeNumber: 966,
  date: "2023-08-25",
  duration: "26m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 967,
  date: "2023-08-25",
  duration: "95h 45m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 7.38
}, {
  tradeNumber: 968,
  date: "2023-08-28",
  duration: "8m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 969,
  date: "2023-08-29",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 12.83
}, {
  tradeNumber: 970,
  date: "2023-08-30",
  duration: "29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 971,
  date: "2023-08-31",
  duration: "11h 33m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 972,
  date: "2023-09-01",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.67
}, {
  tradeNumber: 973,
  date: "2023-09-01",
  duration: "1h 56m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 974,
  date: "2023-09-04",
  duration: "12h 08m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 975,
  date: "2023-09-04",
  duration: "1h 30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 976,
  date: "2023-09-05",
  duration: "6h 18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 977,
  date: "2023-09-05",
  duration: "11h 00m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 978,
  date: "2023-09-06",
  duration: "30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 979,
  date: "2023-09-06",
  duration: "27m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 980,
  date: "2023-09-07",
  duration: "59m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 981,
  date: "2023-09-08",
  duration: "7h 44m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 982,
  date: "2023-09-08",
  duration: "5h 09m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 983,
  date: "2023-09-11",
  duration: "2h 01m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 984,
  date: "2023-09-11",
  duration: "3h 41m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 985,
  date: "2023-09-11",
  duration: "1h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 986,
  date: "2023-09-12",
  duration: "4h 31m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 987,
  date: "2023-09-12",
  duration: "10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 988,
  date: "2023-09-13",
  duration: "10h 50m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 989,
  date: "2023-09-13",
  duration: "35m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 990,
  date: "2023-09-13",
  duration: "12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 991,
  date: "2023-09-14",
  duration: "11h 44m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 992,
  date: "2023-09-14",
  duration: "5h 14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.65
}, {
  tradeNumber: 993,
  date: "2023-09-15",
  duration: "137h 33m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 13.49
}, {
  tradeNumber: 994,
  date: "2023-09-15",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 4.74
}, {
  tradeNumber: 995,
  date: "2023-09-18",
  duration: "3m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 996,
  date: "2023-09-19",
  duration: "4h 17m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 997,
  date: "2023-09-21",
  duration: "20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 998,
  date: "2023-09-22",
  duration: "36m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 999,
  date: "2023-09-22",
  duration: "38m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1000,
  date: "2023-09-25",
  duration: "4h 26m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.59
}, {
  tradeNumber: 1001,
  date: "2023-09-25",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.31
}, {
  tradeNumber: 1002,
  date: "2023-09-25",
  duration: "12h 14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.21
}, {
  tradeNumber: 1003,
  date: "2023-09-26",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.73
}, {
  tradeNumber: 1004,
  date: "2023-09-27",
  duration: "14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1005,
  date: "2023-09-27",
  duration: "4h 50m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.95
}, {
  tradeNumber: 1006,
  date: "2023-09-27",
  duration: "14h 47m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.18
}, {
  tradeNumber: 1007,
  date: "2023-09-29",
  duration: "5h 00m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1008,
  date: "2023-09-29",
  duration: "1h 59m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1009,
  date: "2023-09-29",
  duration: "1h 32m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1010,
  date: "2023-10-02",
  duration: "6h 24m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.43
}, {
  tradeNumber: 1011,
  date: "2023-10-02",
  duration: "3h 41m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1012,
  date: "2023-10-03",
  duration: "6h 07m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.59
}, {
  tradeNumber: 1013,
  date: "2023-10-04",
  duration: "4h 44m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1014,
  date: "2023-10-04",
  duration: "4m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1015,
  date: "2023-10-05",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.33
}, {
  tradeNumber: 1016,
  date: "2023-10-05",
  duration: "13m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1017,
  date: "2023-10-06",
  duration: "7h 01m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1018,
  date: "2023-10-06",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1019,
  date: "2023-10-06",
  duration: "97h 01m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 7.35
}, {
  tradeNumber: 1020,
  date: "2023-10-09",
  duration: "1h 05m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1021,
  date: "2023-10-11",
  duration: "4h 45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.02
}, {
  tradeNumber: 1022,
  date: "2023-10-11",
  duration: "4h 09m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1023,
  date: "2023-10-12",
  duration: "53m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1024,
  date: "2023-10-13",
  duration: "79h 01m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.14
}, {
  tradeNumber: 1025,
  date: "2023-10-13",
  duration: "30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1026,
  date: "2023-10-16",
  duration: "6h 28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.68
}, {
  tradeNumber: 1027,
  date: "2023-10-16",
  duration: "20h 20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.28
}, {
  tradeNumber: 1028,
  date: "2023-10-17",
  duration: "45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1029,
  date: "2023-10-19",
  duration: "10h 11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.42
}, {
  tradeNumber: 1030,
  date: "2023-10-19",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1031,
  date: "2023-10-20",
  duration: "8h 59m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.35
}, {
  tradeNumber: 1032,
  date: "2023-10-20",
  duration: "27m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1033,
  date: "2023-10-20",
  duration: "61h 39m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1034,
  date: "2023-10-23",
  duration: "9m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1035,
  date: "2023-10-23",
  duration: "49h 58m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.26
}, {
  tradeNumber: 1036,
  date: "2023-10-24",
  duration: "7m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1037,
  date: "2023-10-25",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 8.21
}, {
  tradeNumber: 1038,
  date: "2023-10-26",
  duration: "8m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1039,
  date: "2023-10-27",
  duration: "5h 56m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1040,
  date: "2023-10-27",
  duration: "16m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1041,
  date: "2023-10-30",
  duration: "37m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1042,
  date: "2023-10-30",
  duration: "24h 13m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1043,
  date: "2023-10-31",
  duration: "18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1044,
  date: "2023-11-01",
  duration: "28h 08m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 13.44
}, {
  tradeNumber: 1045,
  date: "2023-11-01",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 7.67
}, {
  tradeNumber: 1046,
  date: "2023-11-03",
  duration: "40m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1047,
  date: "2023-11-06",
  duration: "28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1048,
  date: "2023-11-07",
  duration: "56h 08m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.48
}, {
  tradeNumber: 1049,
  date: "2023-11-07",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1050,
  date: "2023-11-08",
  duration: "7m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1051,
  date: "2023-11-09",
  duration: "37m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1052,
  date: "2023-11-10",
  duration: "97h 55m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 16.17
}, {
  tradeNumber: 1053,
  date: "2023-11-10",
  duration: "6h 23m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 10.94
}, {
  tradeNumber: 1054,
  date: "2023-11-13",
  duration: "1h 06m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1055,
  date: "2023-11-14",
  duration: "6h 16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.74
}, {
  tradeNumber: 1056,
  date: "2023-11-15",
  duration: "6h 12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1057,
  date: "2023-11-15",
  duration: "6h 27m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.08
}, {
  tradeNumber: 1058,
  date: "2023-11-15",
  duration: "3h 08m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1059,
  date: "2023-11-16",
  duration: "349h 42m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.62
}, {
  tradeNumber: 1060,
  date: "2023-11-16",
  duration: "24m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1061,
  date: "2023-11-16",
  duration: "1h 32m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1062,
  date: "2023-11-17",
  duration: "2h 38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1063,
  date: "2023-11-20",
  duration: "33m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1064,
  date: "2023-11-21",
  duration: "5h 58m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.21
}, {
  tradeNumber: 1065,
  date: "2023-11-23",
  duration: "3h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.06
}, {
  tradeNumber: 1066,
  date: "2023-11-24",
  duration: "3h 44m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.14
}, {
  tradeNumber: 1067,
  date: "2023-11-27",
  duration: "6m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1068,
  date: "2023-11-28",
  duration: "2h 35m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1069,
  date: "2023-11-29",
  duration: "36m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1070,
  date: "2023-11-30",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.52
}, {
  tradeNumber: 1071,
  date: "2023-12-01",
  duration: "8h 16m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1072,
  date: "2023-12-04",
  duration: "52m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1073,
  date: "2023-12-04",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1074,
  date: "2023-12-05",
  duration: "5h 09m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.02
}, {
  tradeNumber: 1075,
  date: "2023-12-06",
  duration: "13h 40m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1076,
  date: "2023-12-06",
  duration: "1m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1077,
  date: "2023-12-07",
  duration: "127h 55m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 14.41
}, {
  tradeNumber: 1078,
  date: "2023-12-07",
  duration: "18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1079,
  date: "2023-12-07",
  duration: "56m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1080,
  date: "2023-12-11",
  duration: "6h 18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.8
}, {
  tradeNumber: 1081,
  date: "2023-12-12",
  duration: "28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1082,
  date: "2023-12-12",
  duration: "1h 05m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1083,
  date: "2023-12-13",
  duration: "6h 17m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1084,
  date: "2023-12-13",
  duration: "3h 35m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1085,
  date: "2023-12-13",
  duration: "22m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1086,
  date: "2023-12-13",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1087,
  date: "2023-12-14",
  duration: "1h 47m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1088,
  date: "2023-12-14",
  duration: "2m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1089,
  date: "2023-12-18",
  duration: "1h 08m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1090,
  date: "2023-12-18",
  duration: "6h 02m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.5
}, {
  tradeNumber: 1091,
  date: "2023-12-19",
  duration: "12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1092,
  date: "2023-12-20",
  duration: "4h 59m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1093,
  date: "2023-12-20",
  duration: "9m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1094,
  date: "2023-12-22",
  duration: "17m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1095,
  date: "2023-12-22",
  duration: "164h 44m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.78
}, {
  tradeNumber: 1096,
  date: "2023-12-26",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.94
}, {
  tradeNumber: 1097,
  date: "2023-12-27",
  duration: "3h 01m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1098,
  date: "2023-12-28",
  duration: "6h 15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.82
}, {
  tradeNumber: 1099,
  date: "2023-12-29",
  duration: "1h 09m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1100,
  date: "2024-01-02",
  duration: "54h 36m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 18.31
}, {
  tradeNumber: 1101,
  date: "2024-01-03",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1102,
  date: "2024-01-04",
  duration: "2m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1103,
  date: "2024-01-05",
  duration: "1h 23m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1104,
  date: "2024-01-05",
  duration: "3h 46m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1105,
  date: "2024-01-08",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 15.13
}, {
  tradeNumber: 1106,
  date: "2024-01-10",
  duration: "32m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1107,
  date: "2024-01-10",
  duration: "3h 03m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1108,
  date: "2024-01-10",
  duration: "5h 17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.76
}, {
  tradeNumber: 1109,
  date: "2024-01-11",
  duration: "1h 00m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1110,
  date: "2024-01-11",
  duration: "18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1111,
  date: "2024-01-12",
  duration: "4h 07m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1112,
  date: "2024-01-12",
  duration: "1h 02m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1113,
  date: "2024-01-12",
  duration: "30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1114,
  date: "2024-01-15",
  duration: "1h 08m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1115,
  date: "2024-01-15",
  duration: "1h 01m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1116,
  date: "2024-01-16",
  duration: "2h 05m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1117,
  date: "2024-01-16",
  duration: "11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1118,
  date: "2024-01-16",
  duration: "1h 10m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.83
}, {
  tradeNumber: 1119,
  date: "2024-01-17",
  duration: "47m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1120,
  date: "2024-01-17",
  duration: "1h 21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1121,
  date: "2024-01-18",
  duration: "12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1122,
  date: "2024-01-19",
  duration: "1h 56m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1123,
  date: "2024-01-19",
  duration: "30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1124,
  date: "2024-01-22",
  duration: "7h 15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.06
}, {
  tradeNumber: 1125,
  date: "2024-01-23",
  duration: "6h 23m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1126,
  date: "2024-01-23",
  duration: "5h 41m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1127,
  date: "2024-01-23",
  duration: "62h 08m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.88
}, {
  tradeNumber: 1128,
  date: "2024-01-24",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1129,
  date: "2024-01-25",
  duration: "14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1130,
  date: "2024-01-26",
  duration: "59h 41m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.54
}, {
  tradeNumber: 1131,
  date: "2024-01-26",
  duration: "52m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1132,
  date: "2024-01-29",
  duration: "22m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1133,
  date: "2024-01-30",
  duration: "1h 37m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1134,
  date: "2024-01-31",
  duration: "4m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1135,
  date: "2024-01-31",
  duration: "21h 25m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.23
}, {
  tradeNumber: 1136,
  date: "2024-02-01",
  duration: "38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1137,
  date: "2024-02-02",
  duration: "38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.4
}, {
  tradeNumber: 1138,
  date: "2024-02-02",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.21
}, {
  tradeNumber: 1139,
  date: "2024-02-02",
  duration: "46m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1140,
  date: "2024-02-05",
  duration: "1h 06m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1141,
  date: "2024-02-05",
  duration: "20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1142,
  date: "2024-02-05",
  duration: "20h 54m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.3
}, {
  tradeNumber: 1143,
  date: "2024-02-06",
  duration: "7m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1144,
  date: "2024-02-07",
  duration: "12h 02m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1145,
  date: "2024-02-07",
  duration: "5h 46m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.37
}, {
  tradeNumber: 1146,
  date: "2024-02-08",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.65
}, {
  tradeNumber: 1147,
  date: "2024-02-09",
  duration: "3h 56m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1148,
  date: "2024-02-09",
  duration: "29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1149,
  date: "2024-02-12",
  duration: "4h 25m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1150,
  date: "2024-02-12",
  duration: "3h 00m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1151,
  date: "2024-02-13",
  duration: "7m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1152,
  date: "2024-02-13",
  duration: "51m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1153,
  date: "2024-02-14",
  duration: "10m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1154,
  date: "2024-02-15",
  duration: "3h 10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.01
}, {
  tradeNumber: 1155,
  date: "2024-02-15",
  duration: "3h 27m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1156,
  date: "2024-02-16",
  duration: "38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1157,
  date: "2024-02-16",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 6.99
}, {
  tradeNumber: 1158,
  date: "2024-02-16",
  duration: "6m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1159,
  date: "2024-02-19",
  duration: "57h 36m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.89
}, {
  tradeNumber: 1160,
  date: "2024-02-19",
  duration: "3h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.38
}, {
  tradeNumber: 1161,
  date: "2024-02-20",
  duration: "6h 22m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.95
}, {
  tradeNumber: 1162,
  date: "2024-02-21",
  duration: "26m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1163,
  date: "2024-02-23",
  duration: "27m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1164,
  date: "2024-02-25",
  duration: "58h 41m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1165,
  date: "2024-02-26",
  duration: "1h 35m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1166,
  date: "2024-02-27",
  duration: "39m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1167,
  date: "2024-02-28",
  duration: "1h 47m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1168,
  date: "2024-02-28",
  duration: "6h 53m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1169,
  date: "2024-02-29",
  duration: "8h 12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.89
}, {
  tradeNumber: 1170,
  date: "2024-02-29",
  duration: "43m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1171,
  date: "2024-03-01",
  duration: "13h 05m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1172,
  date: "2024-03-01",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 5.29
}, {
  tradeNumber: 1173,
  date: "2024-03-04",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.87
}, {
  tradeNumber: 1174,
  date: "2024-03-04",
  duration: "70h 18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.08
}, {
  tradeNumber: 1175,
  date: "2024-03-05",
  duration: "6h 16m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.98
}, {
  tradeNumber: 1176,
  date: "2024-03-07",
  duration: "15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1177,
  date: "2024-03-07",
  duration: "5h 44m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.8
}, {
  tradeNumber: 1178,
  date: "2024-03-08",
  duration: "5h 20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1179,
  date: "2024-03-08",
  duration: "1h 21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1180,
  date: "2024-03-08",
  duration: "4h 51m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 5.18
}, {
  tradeNumber: 1181,
  date: "2024-03-11",
  duration: "4h 02m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1182,
  date: "2024-03-11",
  duration: "1h 43m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1183,
  date: "2024-03-12",
  duration: "1h 22m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.35
}, {
  tradeNumber: 1184,
  date: "2024-03-12",
  duration: "17m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1185,
  date: "2024-03-13",
  duration: "25h 17m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.69
}, {
  tradeNumber: 1186,
  date: "2024-03-13",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.92
}, {
  tradeNumber: 1187,
  date: "2024-03-14",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1188,
  date: "2024-03-15",
  duration: "12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1189,
  date: "2024-03-15",
  duration: "1h 17m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1190,
  date: "2024-03-18",
  duration: "17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1191,
  date: "2024-03-19",
  duration: "4h 22m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.5
}, {
  tradeNumber: 1192,
  date: "2024-03-19",
  duration: "7m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1193,
  date: "2024-03-20",
  duration: "13m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1194,
  date: "2024-03-21",
  duration: "8m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1195,
  date: "2024-03-22",
  duration: "9h 42m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1196,
  date: "2024-03-22",
  duration: "5h 57m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.47
}, {
  tradeNumber: 1197,
  date: "2024-03-22",
  duration: "69h 03m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.62
}, {
  tradeNumber: 1198,
  date: "2024-03-25",
  duration: "28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1199,
  date: "2024-03-27",
  duration: "3m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1200,
  date: "2024-03-27",
  duration: "7m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1201,
  date: "2024-03-27",
  duration: "24m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1202,
  date: "2024-03-28",
  duration: "1h 51m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1203,
  date: "2024-04-01",
  duration: "71h 13m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.7
}, {
  tradeNumber: 1204,
  date: "2024-04-01",
  duration: "5h 08m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.42
}, {
  tradeNumber: 1205,
  date: "2024-04-02",
  duration: "3h 38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1206,
  date: "2024-04-04",
  duration: "17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1207,
  date: "2024-04-05",
  duration: "1h 37m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.43
}, {
  tradeNumber: 1208,
  date: "2024-04-05",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1209,
  date: "2024-04-08",
  duration: "30h 25m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.36
}, {
  tradeNumber: 1210,
  date: "2024-04-08",
  duration: "4m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1211,
  date: "2024-04-09",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1212,
  date: "2024-04-09",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1213,
  date: "2024-04-10",
  duration: "3h 33m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1214,
  date: "2024-04-10",
  duration: "3m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1215,
  date: "2024-04-10",
  duration: "1m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1216,
  date: "2024-04-11",
  duration: "24h 58m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.26
}, {
  tradeNumber: 1217,
  date: "2024-04-11",
  duration: "4h 18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.37
}, {
  tradeNumber: 1218,
  date: "2024-04-12",
  duration: "5h 52m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.02
}, {
  tradeNumber: 1219,
  date: "2024-04-15",
  duration: "6h 58m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1220,
  date: "2024-04-16",
  duration: "14h 17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.16
}, {
  tradeNumber: 1221,
  date: "2024-04-16",
  duration: "45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1222,
  date: "2024-04-17",
  duration: "1h 11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1223,
  date: "2024-04-18",
  duration: "1h 26m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1224,
  date: "2024-04-18",
  duration: "4m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1225,
  date: "2024-04-18",
  duration: "11h 36m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 8.34
}, {
  tradeNumber: 1226,
  date: "2024-04-18",
  duration: "2h 35m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.12
}, {
  tradeNumber: 1227,
  date: "2024-04-19",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 9.15
}, {
  tradeNumber: 1228,
  date: "2024-04-22",
  duration: "1h 38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.11
}, {
  tradeNumber: 1229,
  date: "2024-04-23",
  duration: "14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1230,
  date: "2024-04-23",
  duration: "6h 17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.29
}, {
  tradeNumber: 1231,
  date: "2024-04-24",
  duration: "1h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1232,
  date: "2024-04-24",
  duration: "1h 15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1233,
  date: "2024-04-24",
  duration: "27m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1234,
  date: "2024-04-25",
  duration: "7h 33m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1235,
  date: "2024-04-25",
  duration: "41m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1236,
  date: "2024-04-25",
  duration: "1h 42m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1237,
  date: "2024-04-26",
  duration: "1h 30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1238,
  date: "2024-04-26",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1239,
  date: "2024-04-29",
  duration: "62h 01m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 9.75
}, {
  tradeNumber: 1240,
  date: "2024-04-29",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.22
}, {
  tradeNumber: 1241,
  date: "2024-04-30",
  duration: "1h 39m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1242,
  date: "2024-05-01",
  duration: "1h 51m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1243,
  date: "2024-05-02",
  duration: "6h 52m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.19
}, {
  tradeNumber: 1244,
  date: "2024-05-02",
  duration: "3h 33m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1245,
  date: "2024-05-03",
  duration: "38m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1246,
  date: "2024-05-06",
  duration: "6h 24m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 3.5
}, {
  tradeNumber: 1247,
  date: "2024-05-07",
  duration: "10h 06m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1248,
  date: "2024-05-07",
  duration: "3h 37m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1249,
  date: "2024-05-08",
  duration: "6h 14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.97
}, {
  tradeNumber: 1250,
  date: "2024-05-08",
  duration: "40h 18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1251,
  date: "2024-05-09",
  duration: "59m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1252,
  date: "2024-05-10",
  duration: "2h 51m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.93
}, {
  tradeNumber: 1253,
  date: "2024-05-10",
  duration: "31m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1254,
  date: "2024-05-13",
  duration: "7h 13m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1255,
  date: "2024-05-13",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.22
}, {
  tradeNumber: 1256,
  date: "2024-05-14",
  duration: "146h 09m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 17.02
}, {
  tradeNumber: 1257,
  date: "2024-05-14",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.79
}, {
  tradeNumber: 1258,
  date: "2024-05-16",
  duration: "1h 14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1259,
  date: "2024-05-17",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.29
}, {
  tradeNumber: 1260,
  date: "2024-05-20",
  duration: "3m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1261,
  date: "2024-05-21",
  duration: "26m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1262,
  date: "2024-05-21",
  duration: "33m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1263,
  date: "2024-05-21",
  duration: "4h 38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1264,
  date: "2024-05-22",
  duration: "5h 58m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.97
}, {
  tradeNumber: 1265,
  date: "2024-05-23",
  duration: "1h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1266,
  date: "2024-05-23",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 14.77
}, {
  tradeNumber: 1267,
  date: "2024-05-24",
  duration: "4h 05m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1268,
  date: "2024-05-24",
  duration: "6m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1269,
  date: "2024-05-27",
  duration: "36h 44m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.76
}, {
  tradeNumber: 1270,
  date: "2024-05-27",
  duration: "3h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 3.23
}, {
  tradeNumber: 1271,
  date: "2024-05-28",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1272,
  date: "2024-05-28",
  duration: "3m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1273,
  date: "2024-05-29",
  duration: "40m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1274,
  date: "2024-05-30",
  duration: "10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1275,
  date: "2024-05-30",
  duration: "4h 43m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1276,
  date: "2024-05-31",
  duration: "10h 41m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1277,
  date: "2024-05-31",
  duration: "6m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1278,
  date: "2024-05-31",
  duration: "6h 28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.05
}, {
  tradeNumber: 1279,
  date: "2024-05-31",
  duration: "10m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1280,
  date: "2024-05-31",
  duration: "11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1281,
  date: "2024-06-03",
  duration: "11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1282,
  date: "2024-06-03",
  duration: "15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1283,
  date: "2024-06-04",
  duration: "4m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1284,
  date: "2024-06-04",
  duration: "4h 02m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1285,
  date: "2024-06-04",
  duration: "10h 52m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1286,
  date: "2024-06-05",
  duration: "8m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1287,
  date: "2024-06-06",
  duration: "6m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1288,
  date: "2024-06-07",
  duration: "8m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1289,
  date: "2024-06-07",
  duration: "4h 25m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1290,
  date: "2024-06-10",
  duration: "4m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1291,
  date: "2024-06-10",
  duration: "36m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1292,
  date: "2024-06-11",
  duration: "17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1293,
  date: "2024-06-11",
  duration: "3h 04m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1294,
  date: "2024-06-12",
  duration: "7h 06m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1295,
  date: "2024-06-12",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.88
}, {
  tradeNumber: 1296,
  date: "2024-06-12",
  duration: "1h 35m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1297,
  date: "2024-06-13",
  duration: "4h 50m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.59
}, {
  tradeNumber: 1298,
  date: "2024-06-14",
  duration: "9h 06m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.77
}, {
  tradeNumber: 1299,
  date: "2024-06-14",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.42
}, {
  tradeNumber: 1300,
  date: "2024-06-14",
  duration: "52h 45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1301,
  date: "2024-06-17",
  duration: "23m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1302,
  date: "2024-06-18",
  duration: "5h 27m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1303,
  date: "2024-06-18",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.68
}, {
  tradeNumber: 1304,
  date: "2024-06-18",
  duration: "31h 49m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1305,
  date: "2024-06-19",
  duration: "3h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.42
}, {
  tradeNumber: 1306,
  date: "2024-06-20",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 8.28
}, {
  tradeNumber: 1307,
  date: "2024-06-20",
  duration: "38m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1308,
  date: "2024-06-21",
  duration: "8h 05m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.59
}, {
  tradeNumber: 1309,
  date: "2024-06-24",
  duration: "43m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1310,
  date: "2024-06-24",
  duration: "11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1311,
  date: "2024-06-24",
  duration: "59m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.48
}, {
  tradeNumber: 1312,
  date: "2024-06-25",
  duration: "78h 05m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 10.88
}, {
  tradeNumber: 1313,
  date: "2024-06-27",
  duration: "17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1314,
  date: "2024-06-28",
  duration: "13m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1315,
  date: "2024-07-01",
  duration: "2h 38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1316,
  date: "2024-07-01",
  duration: "26m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1317,
  date: "2024-07-02",
  duration: "4h 42m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1318,
  date: "2024-07-02",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 10.82
}, {
  tradeNumber: 1319,
  date: "2024-07-02",
  duration: "10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1320,
  date: "2024-07-03",
  duration: "131h 14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 14.61
}, {
  tradeNumber: 1321,
  date: "2024-07-04",
  duration: "3h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.68
}, {
  tradeNumber: 1322,
  date: "2024-07-05",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.21
}, {
  tradeNumber: 1323,
  date: "2024-07-08",
  duration: "4m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1324,
  date: "2024-07-09",
  duration: "13h 38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.21
}, {
  tradeNumber: 1325,
  date: "2024-07-10",
  duration: "7m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1326,
  date: "2024-07-11",
  duration: "1h 36m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1327,
  date: "2024-07-11",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 10.72
}, {
  tradeNumber: 1328,
  date: "2024-07-12",
  duration: "67h 50m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.01
}, {
  tradeNumber: 1329,
  date: "2024-07-15",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1330,
  date: "2024-07-15",
  duration: "2h 18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1331,
  date: "2024-07-16",
  duration: "2h 10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.53
}, {
  tradeNumber: 1332,
  date: "2024-07-17",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 10.09
}, {
  tradeNumber: 1333,
  date: "2024-07-18",
  duration: "7h 03m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1334,
  date: "2024-07-18",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.46
}, {
  tradeNumber: 1335,
  date: "2024-07-19",
  duration: "9m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1336,
  date: "2024-07-22",
  duration: "3h 25m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1337,
  date: "2024-07-22",
  duration: "1m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1338,
  date: "2024-07-23",
  duration: "3h 57m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1339,
  date: "2024-07-23",
  duration: "9m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1340,
  date: "2024-07-24",
  duration: "27m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1341,
  date: "2024-07-24",
  duration: "6h 12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 5.64
}, {
  tradeNumber: 1342,
  date: "2024-07-25",
  duration: "1h 01m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1343,
  date: "2024-07-25",
  duration: "11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1344,
  date: "2024-07-26",
  duration: "2h 20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1345,
  date: "2024-07-29",
  duration: "15h 09m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.83
}, {
  tradeNumber: 1346,
  date: "2024-07-29",
  duration: "15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1347,
  date: "2024-07-30",
  duration: "12h 26m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.97
}, {
  tradeNumber: 1348,
  date: "2024-07-30",
  duration: "24m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1349,
  date: "2024-07-31",
  duration: "4h 07m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1350,
  date: "2024-08-01",
  duration: "5h 09m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.91
}, {
  tradeNumber: 1351,
  date: "2024-08-01",
  duration: "11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1352,
  date: "2024-08-01",
  duration: "15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1353,
  date: "2024-08-02",
  duration: "4m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1354,
  date: "2024-08-02",
  duration: "5h 26m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1355,
  date: "2024-08-02",
  duration: "9m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.0
}, {
  tradeNumber: 1356,
  date: "2024-08-05",
  duration: "34m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1357,
  date: "2024-08-06",
  duration: "8h 50m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.37
}, {
  tradeNumber: 1358,
  date: "2024-08-06",
  duration: "21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1359,
  date: "2024-08-06",
  duration: "46m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.43
}, {
  tradeNumber: 1360,
  date: "2024-08-07",
  duration: "29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1361,
  date: "2024-08-07",
  duration: "33m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1362,
  date: "2024-08-08",
  duration: "5h 57m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.5
}, {
  tradeNumber: 1363,
  date: "2024-08-09",
  duration: "1h 42m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.68
}, {
  tradeNumber: 1364,
  date: "2024-08-09",
  duration: "5h 47m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.73
}, {
  tradeNumber: 1365,
  date: "2024-08-09",
  duration: "69h 11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1366,
  date: "2024-08-12",
  duration: "1h 06m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.0
}, {
  tradeNumber: 1367,
  date: "2024-08-13",
  duration: "4h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.13
}, {
  tradeNumber: 1368,
  date: "2024-08-13",
  duration: "1h 01m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1369,
  date: "2024-08-13",
  duration: "6h 28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.31
}, {
  tradeNumber: 1370,
  date: "2024-08-14",
  duration: "4h 21m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1371,
  date: "2024-08-14",
  duration: "1h 22m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1372,
  date: "2024-08-15",
  duration: "10h 23m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1373,
  date: "2024-08-15",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.26
}, {
  tradeNumber: 1374,
  date: "2024-08-16",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.82
}, {
  tradeNumber: 1375,
  date: "2024-08-19",
  duration: "7h 39m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.34
}, {
  tradeNumber: 1376,
  date: "2024-08-19",
  duration: "1h 40m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.0
}, {
  tradeNumber: 1377,
  date: "2024-08-19",
  duration: "37m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1378,
  date: "2024-08-20",
  duration: "8h 42m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.55
}, {
  tradeNumber: 1379,
  date: "2024-08-20",
  duration: "5h 33m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.0
}, {
  tradeNumber: 1380,
  date: "2024-08-21",
  duration: "2h 59m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1381,
  date: "2024-08-22",
  duration: "38m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1382,
  date: "2024-08-22",
  duration: "32m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1383,
  date: "2024-08-23",
  duration: "30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1384,
  date: "2024-08-26",
  duration: "58h 24m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 8.57
}, {
  tradeNumber: 1385,
  date: "2024-08-26",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.24
}, {
  tradeNumber: 1386,
  date: "2024-08-28",
  duration: "6h 20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 5.14
}, {
  tradeNumber: 1387,
  date: "2024-08-29",
  duration: "4h 58m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1388,
  date: "2024-08-30",
  duration: "1h 27m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1389,
  date: "2024-08-30",
  duration: "74h 13m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1390,
  date: "2024-09-02",
  duration: "3h 15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.14
}, {
  tradeNumber: 1391,
  date: "2024-09-03",
  duration: "5h 57m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1392,
  date: "2024-09-03",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 6.17
}, {
  tradeNumber: 1393,
  date: "2024-09-04",
  duration: "41m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1394,
  date: "2024-09-04",
  duration: "6h 59m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.92
}, {
  tradeNumber: 1395,
  date: "2024-09-04",
  duration: "11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1396,
  date: "2024-09-05",
  duration: "2h 46m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.96
}, {
  tradeNumber: 1397,
  date: "2024-09-05",
  duration: "4m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1398,
  date: "2024-09-06",
  duration: "6h 15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1399,
  date: "2024-09-06",
  duration: "7m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1400,
  date: "2024-09-06",
  duration: "18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1401,
  date: "2024-09-10",
  duration: "12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1402,
  date: "2024-09-11",
  duration: "1h 22m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1403,
  date: "2024-09-11",
  duration: "3h 28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.7
}, {
  tradeNumber: 1404,
  date: "2024-09-12",
  duration: "12h 45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1405,
  date: "2024-09-12",
  duration: "16h 15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1406,
  date: "2024-09-13",
  duration: "7m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1407,
  date: "2024-09-16",
  duration: "6h 14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1408,
  date: "2024-09-16",
  duration: "1h 22m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.45
}, {
  tradeNumber: 1409,
  date: "2024-09-17",
  duration: "56m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1410,
  date: "2024-09-18",
  duration: "4h 59m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.71
}, {
  tradeNumber: 1411,
  date: "2024-09-18",
  duration: "4h 10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1412,
  date: "2024-09-18",
  duration: "24m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1413,
  date: "2024-09-19",
  duration: "20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1414,
  date: "2024-09-20",
  duration: "6h 20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1415,
  date: "2024-09-20",
  duration: "53h 54m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1416,
  date: "2024-09-20",
  duration: "20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.67
}, {
  tradeNumber: 1417,
  date: "2024-09-23",
  duration: "16h 35m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1418,
  date: "2024-09-24",
  duration: "30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1419,
  date: "2024-09-24",
  duration: "23m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1420,
  date: "2024-09-25",
  duration: "24m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1421,
  date: "2024-09-25",
  duration: "21h 55m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.45
}, {
  tradeNumber: 1422,
  date: "2024-09-26",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.28
}, {
  tradeNumber: 1423,
  date: "2024-09-27",
  duration: "5h 53m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.22
}, {
  tradeNumber: 1424,
  date: "2024-09-30",
  duration: "15h 46m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1425,
  date: "2024-09-30",
  duration: "15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1426,
  date: "2024-10-01",
  duration: "83h 24m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.07
}, {
  tradeNumber: 1427,
  date: "2024-10-01",
  duration: "6h 27m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 6.15
}, {
  tradeNumber: 1428,
  date: "2024-10-02",
  duration: "32m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1429,
  date: "2024-10-03",
  duration: "2m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1430,
  date: "2024-10-04",
  duration: "66h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.83
}, {
  tradeNumber: 1431,
  date: "2024-10-07",
  duration: "24m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1432,
  date: "2024-10-07",
  duration: "3h 48m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1433,
  date: "2024-10-08",
  duration: "6h 23m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 3.43
}, {
  tradeNumber: 1434,
  date: "2024-10-08",
  duration: "43m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1435,
  date: "2024-10-09",
  duration: "5h 52m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.8
}, {
  tradeNumber: 1436,
  date: "2024-10-09",
  duration: "20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1437,
  date: "2024-10-11",
  duration: "10h 55m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.56
}, {
  tradeNumber: 1438,
  date: "2024-10-11",
  duration: "65h 37m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1439,
  date: "2024-10-14",
  duration: "1h 30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1440,
  date: "2024-10-15",
  duration: "36m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1441,
  date: "2024-10-16",
  duration: "13m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1442,
  date: "2024-10-16",
  duration: "44m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1443,
  date: "2024-10-18",
  duration: "13h 13m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.06
}, {
  tradeNumber: 1444,
  date: "2024-10-21",
  duration: "1h 15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1445,
  date: "2024-10-22",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.9
}, {
  tradeNumber: 1446,
  date: "2024-10-23",
  duration: "6h 28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 4.25
}, {
  tradeNumber: 1447,
  date: "2024-10-24",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.38
}, {
  tradeNumber: 1448,
  date: "2024-10-25",
  duration: "4h 08m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1449,
  date: "2024-10-25",
  duration: "3h 57m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1450,
  date: "2024-10-25",
  duration: "66h 24m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.13
}, {
  tradeNumber: 1451,
  date: "2024-10-28",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.54
}, {
  tradeNumber: 1452,
  date: "2024-10-29",
  duration: "2h 16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.57
}, {
  tradeNumber: 1453,
  date: "2024-10-29",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1454,
  date: "2024-10-30",
  duration: "39m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1455,
  date: "2024-10-30",
  duration: "6m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1456,
  date: "2024-10-31",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 12.02
}, {
  tradeNumber: 1457,
  date: "2024-10-31",
  duration: "14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1458,
  date: "2024-11-01",
  duration: "10h 51m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.09
}, {
  tradeNumber: 1459,
  date: "2024-11-01",
  duration: "4m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1460,
  date: "2024-11-03",
  duration: "9h 32m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.04
}, {
  tradeNumber: 1461,
  date: "2024-11-04",
  duration: "2h 03m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1462,
  date: "2024-11-04",
  duration: "28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1463,
  date: "2024-11-05",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 5.6
}, {
  tradeNumber: 1464,
  date: "2024-11-06",
  duration: "3h 15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1465,
  date: "2024-11-06",
  duration: "4m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1466,
  date: "2024-11-07",
  duration: "9h 48m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1467,
  date: "2024-11-07",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 5.96
}, {
  tradeNumber: 1468,
  date: "2024-11-08",
  duration: "7h 04m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.65
}, {
  tradeNumber: 1469,
  date: "2024-11-08",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.71
}, {
  tradeNumber: 1470,
  date: "2024-11-10",
  duration: "9h 18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1471,
  date: "2024-11-11",
  duration: "36m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1472,
  date: "2024-11-11",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.34
}, {
  tradeNumber: 1473,
  date: "2024-11-12",
  duration: "27m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1474,
  date: "2024-11-13",
  duration: "2h 45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1475,
  date: "2024-11-13",
  duration: "54m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1476,
  date: "2024-11-14",
  duration: "9h 34m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1477,
  date: "2024-11-15",
  duration: "20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1478,
  date: "2024-11-15",
  duration: "6h 28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 8.56
}, {
  tradeNumber: 1479,
  date: "2024-11-18",
  duration: "7h 12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.3
}, {
  tradeNumber: 1480,
  date: "2024-11-18",
  duration: "5h 54m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.72
}, {
  tradeNumber: 1481,
  date: "2024-11-19",
  duration: "11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1482,
  date: "2024-11-19",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.05
}, {
  tradeNumber: 1483,
  date: "2024-11-20",
  duration: "20h 31m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.96
}, {
  tradeNumber: 1484,
  date: "2024-11-20",
  duration: "6h 25m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1485,
  date: "2024-11-21",
  duration: "59m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1486,
  date: "2024-11-21",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1487,
  date: "2024-11-22",
  duration: "5h 52m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1488,
  date: "2024-11-22",
  duration: "56h 25m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1489,
  date: "2024-11-22",
  duration: "28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1490,
  date: "2024-11-25",
  duration: "12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1491,
  date: "2024-11-25",
  duration: "19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1492,
  date: "2024-11-26",
  duration: "37h 45m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.07
}, {
  tradeNumber: 1493,
  date: "2024-11-26",
  duration: "23m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1494,
  date: "2024-11-27",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.89
}, {
  tradeNumber: 1495,
  date: "2024-11-28",
  duration: "3h 27m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1496,
  date: "2024-11-28",
  duration: "3h 08m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.04
}, {
  tradeNumber: 1497,
  date: "2024-11-29",
  duration: "1h 44m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1498,
  date: "2024-11-29",
  duration: "55m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1499,
  date: "2024-11-29",
  duration: "3h 31m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.42
}, {
  tradeNumber: 1500,
  date: "2024-12-02",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 3.28
}, {
  tradeNumber: 1501,
  date: "2024-12-03",
  duration: "12h 46m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1502,
  date: "2024-12-03",
  duration: "10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1503,
  date: "2024-12-04",
  duration: "4h 25m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1504,
  date: "2024-12-04",
  duration: "1h 02m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1505,
  date: "2024-12-05",
  duration: "5h 11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1506,
  date: "2024-12-05",
  duration: "3h 54m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1507,
  date: "2024-12-06",
  duration: "40m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1508,
  date: "2024-12-06",
  duration: "6h 17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.57
}, {
  tradeNumber: 1509,
  date: "2024-12-09",
  duration: "40m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1510,
  date: "2024-12-10",
  duration: "1h 23m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1511,
  date: "2024-12-10",
  duration: "2h 34m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1512,
  date: "2024-12-11",
  duration: "24m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1513,
  date: "2024-12-11",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.57
}, {
  tradeNumber: 1514,
  date: "2024-12-12",
  duration: "3h 24m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1515,
  date: "2024-12-12",
  duration: "1h 40m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1516,
  date: "2024-12-12",
  duration: "11h 42m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1517,
  date: "2024-12-13",
  duration: "4h 53m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1518,
  date: "2024-12-16",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 3.97
}, {
  tradeNumber: 1519,
  date: "2024-12-17",
  duration: "1h 34m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1520,
  date: "2024-12-17",
  duration: "2h 06m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1521,
  date: "2024-12-18",
  duration: "51m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1522,
  date: "2024-12-18",
  duration: "1m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1523,
  date: "2024-12-18",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1524,
  date: "2024-12-19",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1525,
  date: "2024-12-20",
  duration: "1h 11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1526,
  date: "2024-12-20",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1527,
  date: "2024-12-23",
  duration: "20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1528,
  date: "2024-12-23",
  duration: "4h 16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.24
}, {
  tradeNumber: 1529,
  date: "2024-12-24",
  duration: "6h 58m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1530,
  date: "2024-12-24",
  duration: "3h 34m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.97
}, {
  tradeNumber: 1531,
  date: "2024-12-26",
  duration: "12h 52m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.47
}, {
  tradeNumber: 1532,
  date: "2024-12-26",
  duration: "23m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1533,
  date: "2024-12-26",
  duration: "21h 49m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 8.17
}, {
  tradeNumber: 1534,
  date: "2024-12-27",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.18
}, {
  tradeNumber: 1535,
  date: "2024-12-30",
  duration: "14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1536,
  date: "2024-12-30",
  duration: "1h 03m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1537,
  date: "2024-12-31",
  duration: "40h 41m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.1
}, {
  tradeNumber: 1538,
  date: "2024-12-31",
  duration: "6h 28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.96
}, {
  tradeNumber: 1539,
  date: "2025-01-02",
  duration: "3h 06m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.93
}, {
  tradeNumber: 1540,
  date: "2025-01-02",
  duration: "22m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1541,
  date: "2025-01-02",
  duration: "16h 26m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.58
}, {
  tradeNumber: 1542,
  date: "2025-01-03",
  duration: "14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1543,
  date: "2025-01-03",
  duration: "50m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1544,
  date: "2025-01-06",
  duration: "1h 35m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1545,
  date: "2025-01-06",
  duration: "4h 05m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1546,
  date: "2025-01-07",
  duration: "7m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1547,
  date: "2025-01-08",
  duration: "1h 14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1548,
  date: "2025-01-09",
  duration: "12h 25m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.12
}, {
  tradeNumber: 1549,
  date: "2025-01-10",
  duration: "7m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1550,
  date: "2025-01-13",
  duration: "6h 52m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1551,
  date: "2025-01-13",
  duration: "24m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1552,
  date: "2025-01-14",
  duration: "5h 12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.02
}, {
  tradeNumber: 1553,
  date: "2025-01-14",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1554,
  date: "2025-01-15",
  duration: "11h 30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 8.08
}, {
  tradeNumber: 1555,
  date: "2025-01-15",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.48
}, {
  tradeNumber: 1556,
  date: "2025-01-15",
  duration: "8h 01m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1557,
  date: "2025-01-16",
  duration: "1h 54m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1558,
  date: "2025-01-20",
  duration: "51m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1559,
  date: "2025-01-21",
  duration: "6m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1560,
  date: "2025-01-21",
  duration: "48m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.93
}, {
  tradeNumber: 1561,
  date: "2025-01-21",
  duration: "2h 54m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1562,
  date: "2025-01-22",
  duration: "5h 16m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1563,
  date: "2025-01-22",
  duration: "6h 10m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.22
}, {
  tradeNumber: 1564,
  date: "2025-01-23",
  duration: "55m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1565,
  date: "2025-01-23",
  duration: "2h 00m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1566,
  date: "2025-01-24",
  duration: "71h 01m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 11.16
}, {
  tradeNumber: 1567,
  date: "2025-01-24",
  duration: "54m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1568,
  date: "2025-01-28",
  duration: "6h 54m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.71
}, {
  tradeNumber: 1569,
  date: "2025-01-28",
  duration: "15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1570,
  date: "2025-01-29",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.83
}, {
  tradeNumber: 1571,
  date: "2025-01-30",
  duration: "6h 47m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1572,
  date: "2025-01-30",
  duration: "16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1573,
  date: "2025-01-31",
  duration: "7h 45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1574,
  date: "2025-01-31",
  duration: "2h 25m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.39
}, {
  tradeNumber: 1575,
  date: "2025-02-03",
  duration: "0m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.0
}, {
  tradeNumber: 1576,
  date: "2025-02-04",
  duration: "6h 09m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.96
}, {
  tradeNumber: 1577,
  date: "2025-02-05",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.91
}, {
  tradeNumber: 1578,
  date: "2025-02-06",
  duration: "48m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1579,
  date: "2025-02-06",
  duration: "3m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1580,
  date: "2025-02-07",
  duration: "12h 57m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1581,
  date: "2025-02-07",
  duration: "30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1582,
  date: "2025-02-10",
  duration: "6h 16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.81
}, {
  tradeNumber: 1583,
  date: "2025-02-10",
  duration: "19h 38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.29
}, {
  tradeNumber: 1584,
  date: "2025-02-11",
  duration: "2h 16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1585,
  date: "2025-02-12",
  duration: "57m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.67
}, {
  tradeNumber: 1586,
  date: "2025-02-12",
  duration: "6h 18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.56
}, {
  tradeNumber: 1587,
  date: "2025-02-13",
  duration: "1h 05m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1588,
  date: "2025-02-13",
  duration: "1h 15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1589,
  date: "2025-02-14",
  duration: "17h 25m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1590,
  date: "2025-02-17",
  duration: "16h 39m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1591,
  date: "2025-02-17",
  duration: "3h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.62
}, {
  tradeNumber: 1592,
  date: "2025-02-18",
  duration: "7h 34m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.25
}, {
  tradeNumber: 1593,
  date: "2025-02-18",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.24
}, {
  tradeNumber: 1594,
  date: "2025-02-19",
  duration: "14h 42m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.4
}, {
  tradeNumber: 1595,
  date: "2025-02-20",
  duration: "2h 35m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1596,
  date: "2025-02-20",
  duration: "13m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1597,
  date: "2025-02-21",
  duration: "8m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1598,
  date: "2025-02-21",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 18.3
}, {
  tradeNumber: 1599,
  date: "2025-02-24",
  duration: "2m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1600,
  date: "2025-02-24",
  duration: "14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1601,
  date: "2025-02-25",
  duration: "2h 32m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1602,
  date: "2025-02-26",
  duration: "20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1603,
  date: "2025-02-27",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 11.98
}, {
  tradeNumber: 1604,
  date: "2025-02-27",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1605,
  date: "2025-02-27",
  duration: "33m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1606,
  date: "2025-02-28",
  duration: "13m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1607,
  date: "2025-02-28",
  duration: "16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.74
}, {
  tradeNumber: 1608,
  date: "2025-03-03",
  duration: "3m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1609,
  date: "2025-03-03",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 7.52
}, {
  tradeNumber: 1610,
  date: "2025-03-03",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1611,
  date: "2025-03-04",
  duration: "2h 31m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1612,
  date: "2025-03-04",
  duration: "1h 20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.52
}, {
  tradeNumber: 1613,
  date: "2025-03-05",
  duration: "4m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1614,
  date: "2025-03-05",
  duration: "22h 43m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.69
}, {
  tradeNumber: 1615,
  date: "2025-03-06",
  duration: "35m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1616,
  date: "2025-03-06",
  duration: "3h 56m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.66
}, {
  tradeNumber: 1617,
  date: "2025-03-07",
  duration: "40m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.85
}, {
  tradeNumber: 1618,
  date: "2025-03-07",
  duration: "31m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.75
}, {
  tradeNumber: 1619,
  date: "2025-03-07",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1620,
  date: "2025-03-07",
  duration: "1h 23m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.47
}, {
  tradeNumber: 1621,
  date: "2025-03-10",
  duration: "4h 37m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1622,
  date: "2025-03-10",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 7.68
}, {
  tradeNumber: 1623,
  date: "2025-03-11",
  duration: "7m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1624,
  date: "2025-03-11",
  duration: "17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.51
}, {
  tradeNumber: 1625,
  date: "2025-03-12",
  duration: "8m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1626,
  date: "2025-03-12",
  duration: "27m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1627,
  date: "2025-03-13",
  duration: "35m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.61
}, {
  tradeNumber: 1628,
  date: "2025-03-14",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1629,
  date: "2025-03-17",
  duration: "1h 02m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1630,
  date: "2025-03-17",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1631,
  date: "2025-03-17",
  duration: "41m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1632,
  date: "2025-03-18",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.12
}, {
  tradeNumber: 1633,
  date: "2025-03-19",
  duration: "13h 26m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1634,
  date: "2025-03-19",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.42
}, {
  tradeNumber: 1635,
  date: "2025-03-20",
  duration: "7m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1636,
  date: "2025-03-20",
  duration: "79h 22m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.78
}, {
  tradeNumber: 1637,
  date: "2025-03-24",
  duration: "1h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1638,
  date: "2025-03-25",
  duration: "46m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1639,
  date: "2025-03-25",
  duration: "59m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1640,
  date: "2025-03-26",
  duration: "25h 55m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 12.78
}, {
  tradeNumber: 1641,
  date: "2025-03-26",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.53
}, {
  tradeNumber: 1642,
  date: "2025-03-27",
  duration: "24m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1643,
  date: "2025-03-27",
  duration: "3h 37m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.98
}, {
  tradeNumber: 1644,
  date: "2025-03-28",
  duration: "7h 43m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1645,
  date: "2025-03-28",
  duration: "1h 05m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1646,
  date: "2025-03-31",
  duration: "38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1647,
  date: "2025-04-01",
  duration: "2h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.81
}, {
  tradeNumber: 1648,
  date: "2025-04-01",
  duration: "15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1649,
  date: "2025-04-01",
  duration: "1h 03m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1650,
  date: "2025-04-02",
  duration: "3m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1651,
  date: "2025-04-03",
  duration: "11h 55m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.57
}, {
  tradeNumber: 1652,
  date: "2025-04-04",
  duration: "1h 50m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1653,
  date: "2025-04-04",
  duration: "7m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1654,
  date: "2025-04-07",
  duration: "18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.0
}, {
  tradeNumber: 1655,
  date: "2025-04-08",
  duration: "1h 36m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1656,
  date: "2025-04-08",
  duration: "1h 42m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1657,
  date: "2025-04-09",
  duration: "6h 28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 14.69
}, {
  tradeNumber: 1658,
  date: "2025-04-09",
  duration: "8m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.26
}, {
  tradeNumber: 1659,
  date: "2025-04-10",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.81
}, {
  tradeNumber: 1660,
  date: "2025-04-10",
  duration: "1h 45m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1661,
  date: "2025-04-11",
  duration: "7m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1662,
  date: "2025-04-11",
  duration: "32m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.29
}, {
  tradeNumber: 1663,
  date: "2025-04-15",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.16
}, {
  tradeNumber: 1664,
  date: "2025-04-15",
  duration: "19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1665,
  date: "2025-04-16",
  duration: "24m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1666,
  date: "2025-04-16",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.05
}, {
  tradeNumber: 1667,
  date: "2025-04-21",
  duration: "4h 14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1668,
  date: "2025-04-21",
  duration: "36m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1669,
  date: "2025-04-22",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.2
}, {
  tradeNumber: 1670,
  date: "2025-04-23",
  duration: "2h 34m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1671,
  date: "2025-04-23",
  duration: "1h 32m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1672,
  date: "2025-04-24",
  duration: "6h 28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.31
}, {
  tradeNumber: 1673,
  date: "2025-04-24",
  duration: "2h 21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1674,
  date: "2025-04-25",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.15
}, {
  tradeNumber: 1675,
  date: "2025-04-25",
  duration: "49m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.65
}, {
  tradeNumber: 1676,
  date: "2025-04-28",
  duration: "39m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.88
}, {
  tradeNumber: 1677,
  date: "2025-04-28",
  duration: "1h 49m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1678,
  date: "2025-04-29",
  duration: "9h 18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.85
}, {
  tradeNumber: 1679,
  date: "2025-04-29",
  duration: "1h 40m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1680,
  date: "2025-04-30",
  duration: "16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1681,
  date: "2025-04-30",
  duration: "51m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1682,
  date: "2025-05-01",
  duration: "8m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1683,
  date: "2025-05-02",
  duration: "39m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1684,
  date: "2025-05-05",
  duration: "11h 02m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.98
}, {
  tradeNumber: 1685,
  date: "2025-05-05",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.56
}, {
  tradeNumber: 1686,
  date: "2025-05-06",
  duration: "50m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1687,
  date: "2025-05-07",
  duration: "1h 22m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1688,
  date: "2025-05-07",
  duration: "6m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.65
}, {
  tradeNumber: 1689,
  date: "2025-05-08",
  duration: "2h 44m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1690,
  date: "2025-05-08",
  duration: "7h 03m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.86
}, {
  tradeNumber: 1691,
  date: "2025-05-08",
  duration: "2h 09m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.0
}, {
  tradeNumber: 1692,
  date: "2025-05-08",
  duration: "8h 28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.71
}, {
  tradeNumber: 1693,
  date: "2025-05-09",
  duration: "64h 09m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 6.15
}, {
  tradeNumber: 1694,
  date: "2025-05-12",
  duration: "3h 02m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1695,
  date: "2025-05-12",
  duration: "10h 05m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.74
}, {
  tradeNumber: 1696,
  date: "2025-05-13",
  duration: "1h 20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1697,
  date: "2025-05-13",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.3
}, {
  tradeNumber: 1698,
  date: "2025-05-14",
  duration: "11h 37m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.1
}, {
  tradeNumber: 1699,
  date: "2025-05-14",
  duration: "2h 18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1700,
  date: "2025-05-15",
  duration: "6h 27m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.34
}, {
  tradeNumber: 1701,
  date: "2025-05-16",
  duration: "6h 55m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.23
}, {
  tradeNumber: 1702,
  date: "2025-05-16",
  duration: "2h 02m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1703,
  date: "2025-05-16",
  duration: "53m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.0
}, {
  tradeNumber: 1704,
  date: "2025-05-19",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.88
}, {
  tradeNumber: 1705,
  date: "2025-05-19",
  duration: "5h 44m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.98
}, {
  tradeNumber: 1706,
  date: "2025-05-20",
  duration: "6h 24m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.58
}, {
  tradeNumber: 1707,
  date: "2025-05-20",
  duration: "9m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1708,
  date: "2025-05-21",
  duration: "4m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1709,
  date: "2025-05-21",
  duration: "2h 35m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.65
}, {
  tradeNumber: 1710,
  date: "2025-05-22",
  duration: "5h 46m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.05
}, {
  tradeNumber: 1711,
  date: "2025-05-23",
  duration: "13m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1712,
  date: "2025-05-26",
  duration: "29h 07m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1713,
  date: "2025-05-27",
  duration: "30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1714,
  date: "2025-05-27",
  duration: "2h 10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1715,
  date: "2025-05-28",
  duration: "6h 11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.71
}, {
  tradeNumber: 1716,
  date: "2025-05-28",
  duration: "4h 59m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1717,
  date: "2025-05-29",
  duration: "7h 59m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 7.05
}, {
  tradeNumber: 1718,
  date: "2025-05-30",
  duration: "15h 23m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1719,
  date: "2025-05-30",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1720,
  date: "2025-05-30",
  duration: "65h 28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.66
}, {
  tradeNumber: 1721,
  date: "2025-06-02",
  duration: "2h 58m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.25
}, {
  tradeNumber: 1722,
  date: "2025-06-03",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.46
}, {
  tradeNumber: 1723,
  date: "2025-06-03",
  duration: "1h 21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1724,
  date: "2025-06-04",
  duration: "2h 10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1725,
  date: "2025-06-04",
  duration: "1h 38m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.5
}, {
  tradeNumber: 1726,
  date: "2025-06-04",
  duration: "30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1727,
  date: "2025-06-05",
  duration: "7h 46m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.84
}, {
  tradeNumber: 1728,
  date: "2025-06-05",
  duration: "1h 12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.33
}, {
  tradeNumber: 1729,
  date: "2025-06-05",
  duration: "47m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1730,
  date: "2025-06-06",
  duration: "1h 48m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1731,
  date: "2025-06-09",
  duration: "8h 24m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1732,
  date: "2025-06-10",
  duration: "20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1733,
  date: "2025-06-11",
  duration: "20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1734,
  date: "2025-06-11",
  duration: "28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1735,
  date: "2025-06-12",
  duration: "7h 14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1736,
  date: "2025-06-12",
  duration: "1h 07m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1737,
  date: "2025-06-12",
  duration: "6h 16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.96
}, {
  tradeNumber: 1738,
  date: "2025-06-12",
  duration: "89h 33m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.0
}, {
  tradeNumber: 1739,
  date: "2025-06-13",
  duration: "4m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1740,
  date: "2025-06-16",
  duration: "6h 14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.4
}, {
  tradeNumber: 1741,
  date: "2025-06-17",
  duration: "10h 27m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1742,
  date: "2025-06-17",
  duration: "2h 49m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1743,
  date: "2025-06-18",
  duration: "4h 59m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.1
}, {
  tradeNumber: 1744,
  date: "2025-06-19",
  duration: "52m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1745,
  date: "2025-06-19",
  duration: "5h 40m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1746,
  date: "2025-06-19",
  duration: "3h 16m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.31
}, {
  tradeNumber: 1747,
  date: "2025-06-20",
  duration: "15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1748,
  date: "2025-06-20",
  duration: "2h 52m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1749,
  date: "2025-06-23",
  duration: "25m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1750,
  date: "2025-06-24",
  duration: "53m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1751,
  date: "2025-06-25",
  duration: "31m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1752,
  date: "2025-06-26",
  duration: "3h 56m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1753,
  date: "2025-06-26",
  duration: "17m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1754,
  date: "2025-06-27",
  duration: "1h 06m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1755,
  date: "2025-06-27",
  duration: "2h 43m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1756,
  date: "2025-06-27",
  duration: "4h 34m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1757,
  date: "2025-06-30",
  duration: "48m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1758,
  date: "2025-06-30",
  duration: "2h 21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1759,
  date: "2025-06-30",
  duration: "17h 42m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.33
}, {
  tradeNumber: 1760,
  date: "2025-07-01",
  duration: "19h 41m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.16
}, {
  tradeNumber: 1761,
  date: "2025-07-02",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 5.81
}, {
  tradeNumber: 1762,
  date: "2025-07-02",
  duration: "40m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1763,
  date: "2025-07-03",
  duration: "21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1764,
  date: "2025-07-03",
  duration: "3h 44m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 3.42
}, {
  tradeNumber: 1765,
  date: "2025-07-04",
  duration: "3h 27m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.01
}, {
  tradeNumber: 1766,
  date: "2025-07-07",
  duration: "4h 06m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.67
}, {
  tradeNumber: 1767,
  date: "2025-07-07",
  duration: "6h 26m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.16
}, {
  tradeNumber: 1768,
  date: "2025-07-08",
  duration: "2h 57m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1769,
  date: "2025-07-09",
  duration: "14h 22m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.51
}, {
  tradeNumber: 1770,
  date: "2025-07-09",
  duration: "1h 06m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1771,
  date: "2025-07-10",
  duration: "3h 47m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.81
}, {
  tradeNumber: 1772,
  date: "2025-07-10",
  duration: "3m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1773,
  date: "2025-07-11",
  duration: "17h 06m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.2
}, {
  tradeNumber: 1774,
  date: "2025-07-11",
  duration: "11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1775,
  date: "2025-07-14",
  duration: "12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1776,
  date: "2025-07-15",
  duration: "2h 18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1777,
  date: "2025-07-15",
  duration: "45h 40m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.39
}, {
  tradeNumber: 1778,
  date: "2025-07-15",
  duration: "35m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1779,
  date: "2025-07-16",
  duration: "3h 25m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1780,
  date: "2025-07-17",
  duration: "1h 42m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1781,
  date: "2025-07-17",
  duration: "21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1782,
  date: "2025-07-18",
  duration: "5h 52m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.11
}, {
  tradeNumber: 1783,
  date: "2025-07-21",
  duration: "10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1784,
  date: "2025-07-21",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.35
}, {
  tradeNumber: 1785,
  date: "2025-07-22",
  duration: "4h 20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1786,
  date: "2025-07-22",
  duration: "1m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1787,
  date: "2025-07-22",
  duration: "6m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1788,
  date: "2025-07-22",
  duration: "24h 46m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1789,
  date: "2025-07-23",
  duration: "0m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.0
}, {
  tradeNumber: 1790,
  date: "2025-07-24",
  duration: "39h 04m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1791,
  date: "2025-07-24",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1792,
  date: "2025-07-25",
  duration: "20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1793,
  date: "2025-07-28",
  duration: "13h 00m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.82
}, {
  tradeNumber: 1794,
  date: "2025-07-28",
  duration: "6m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1795,
  date: "2025-07-29",
  duration: "20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1796,
  date: "2025-07-29",
  duration: "22h 54m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.54
}, {
  tradeNumber: 1797,
  date: "2025-07-30",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1798,
  date: "2025-07-31",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 17.79
}, {
  tradeNumber: 1799,
  date: "2025-08-01",
  duration: "30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1800,
  date: "2025-08-04",
  duration: "6h 17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.63
}, {
  tradeNumber: 1801,
  date: "2025-08-05",
  duration: "27h 14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.47
}, {
  tradeNumber: 1802,
  date: "2025-08-05",
  duration: "18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1803,
  date: "2025-08-06",
  duration: "2m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1804,
  date: "2025-08-06",
  duration: "4m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1805,
  date: "2025-08-07",
  duration: "58m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1806,
  date: "2025-08-07",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1807,
  date: "2025-08-07",
  duration: "51m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1808,
  date: "2025-08-11",
  duration: "3h 13m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1809,
  date: "2025-08-12",
  duration: "40m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.83
}, {
  tradeNumber: 1810,
  date: "2025-08-12",
  duration: "4m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1811,
  date: "2025-08-13",
  duration: "35m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1812,
  date: "2025-08-14",
  duration: "1h 15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.66
}, {
  tradeNumber: 1813,
  date: "2025-08-14",
  duration: "1h 51m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1814,
  date: "2025-08-14",
  duration: "6h 18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.03
}, {
  tradeNumber: 1815,
  date: "2025-08-14",
  duration: "18h 20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.22
}, {
  tradeNumber: 1816,
  date: "2025-08-18",
  duration: "23h 34m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1817,
  date: "2025-08-18",
  duration: "6m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1818,
  date: "2025-08-19",
  duration: "24h 09m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 11.23
}, {
  tradeNumber: 1819,
  date: "2025-08-19",
  duration: "18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1820,
  date: "2025-08-20",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.54
}, {
  tradeNumber: 1821,
  date: "2025-08-21",
  duration: "11h 49m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.95
}, {
  tradeNumber: 1822,
  date: "2025-08-21",
  duration: "0m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.0
}, {
  tradeNumber: 1823,
  date: "2025-08-22",
  duration: "0m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.0
}, {
  tradeNumber: 1824,
  date: "2025-08-22",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 5.14
}, {
  tradeNumber: 1825,
  date: "2025-08-25",
  duration: "4m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1826,
  date: "2025-08-25",
  duration: "9h 27m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.39
}, {
  tradeNumber: 1827,
  date: "2025-08-27",
  duration: "49m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1828,
  date: "2025-08-27",
  duration: "49m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1829,
  date: "2025-08-27",
  duration: "3h 54m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1830,
  date: "2025-08-28",
  duration: "5h 25m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1831,
  date: "2025-08-28",
  duration: "9m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1832,
  date: "2025-08-29",
  duration: "8m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1833,
  date: "2025-08-29",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.49
}, {
  tradeNumber: 1834,
  date: "2025-09-01",
  duration: "3h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.45
}, {
  tradeNumber: 1835,
  date: "2025-09-01",
  duration: "7h 45m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1836,
  date: "2025-09-02",
  duration: "1h 35m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1837,
  date: "2025-09-03",
  duration: "2h 58m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1838,
  date: "2025-09-04",
  duration: "16h 31m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1839,
  date: "2025-09-04",
  duration: "3m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1840,
  date: "2025-09-05",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1841,
  date: "2025-09-08",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.15
}, {
  tradeNumber: 1842,
  date: "2025-09-09",
  duration: "1h 28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1843,
  date: "2025-09-09",
  duration: "9h 33m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1844,
  date: "2025-09-10",
  duration: "50m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1845,
  date: "2025-09-10",
  duration: "28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1846,
  date: "2025-09-10",
  duration: "1h 40m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1847,
  date: "2025-09-11",
  duration: "11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1848,
  date: "2025-09-11",
  duration: "19h 04m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1849,
  date: "2025-09-15",
  duration: "5h 54m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1850,
  date: "2025-09-15",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.56
}, {
  tradeNumber: 1851,
  date: "2025-09-16",
  duration: "1h 54m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1852,
  date: "2025-09-16",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.93
}, {
  tradeNumber: 1853,
  date: "2025-09-17",
  duration: "3h 16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1854,
  date: "2025-09-17",
  duration: "4h 30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.04
}, {
  tradeNumber: 1855,
  date: "2025-09-17",
  duration: "5h 44m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1856,
  date: "2025-09-18",
  duration: "20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1857,
  date: "2025-09-18",
  duration: "6h 01m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.25
}, {
  tradeNumber: 1858,
  date: "2025-09-19",
  duration: "58m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1859,
  date: "2025-09-22",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 3.58
}, {
  tradeNumber: 1860,
  date: "2025-09-22",
  duration: "39m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1861,
  date: "2025-09-23",
  duration: "56h 03m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 15.13
}, {
  tradeNumber: 1862,
  date: "2025-09-24",
  duration: "6h 11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.85
}, {
  tradeNumber: 1863,
  date: "2025-09-25",
  duration: "10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1864,
  date: "2025-09-26",
  duration: "1h 28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.06
}, {
  tradeNumber: 1865,
  date: "2025-09-26",
  duration: "3m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1866,
  date: "2025-09-29",
  duration: "4h 23m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.2
}, {
  tradeNumber: 1867,
  date: "2025-09-30",
  duration: "6h 20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1868,
  date: "2025-09-30",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1869,
  date: "2025-10-01",
  duration: "5h 41m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 3.76
}, {
  tradeNumber: 1870,
  date: "2025-10-02",
  duration: "7h 44m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1871,
  date: "2025-10-02",
  duration: "5h 46m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1872,
  date: "2025-10-03",
  duration: "3h 59m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1873,
  date: "2025-10-03",
  duration: "1m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1874,
  date: "2025-10-06",
  duration: "6h 38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1875,
  date: "2025-10-06",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1876,
  date: "2025-10-06",
  duration: "24h 30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.39
}, {
  tradeNumber: 1877,
  date: "2025-10-08",
  duration: "5h 41m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1878,
  date: "2025-10-08",
  duration: "6h 28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 8.24
}, {
  tradeNumber: 1879,
  date: "2025-10-09",
  duration: "5h 01m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1880,
  date: "2025-10-09",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.09
}, {
  tradeNumber: 1881,
  date: "2025-10-10",
  duration: "1h 26m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1882,
  date: "2025-10-13",
  duration: "22m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1883,
  date: "2025-10-14",
  duration: "13h 21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 5.29
}, {
  tradeNumber: 1884,
  date: "2025-10-14",
  duration: "11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1885,
  date: "2025-10-15",
  duration: "11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1886,
  date: "2025-10-16",
  duration: "15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1887,
  date: "2025-10-17",
  duration: "1h 27m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1888,
  date: "2025-10-20",
  duration: "15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1889,
  date: "2025-10-20",
  duration: "6h 10m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.97
}, {
  tradeNumber: 1890,
  date: "2025-10-21",
  duration: "12h 58m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.24
}, {
  tradeNumber: 1891,
  date: "2025-10-21",
  duration: "2h 20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1892,
  date: "2025-10-21",
  duration: "1h 52m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1893,
  date: "2025-10-22",
  duration: "13h 26m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1894,
  date: "2025-10-22",
  duration: "23m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1895,
  date: "2025-10-23",
  duration: "6h 31m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.96
}, {
  tradeNumber: 1896,
  date: "2025-10-23",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 2.15
}, {
  tradeNumber: 1897,
  date: "2025-10-23",
  duration: "12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1898,
  date: "2025-10-24",
  duration: "1h 11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1899,
  date: "2025-10-27",
  duration: "6h 27m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1900,
  date: "2025-10-27",
  duration: "1h 57m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1901,
  date: "2025-10-28",
  duration: "43m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1902,
  date: "2025-10-28",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.12
}, {
  tradeNumber: 1903,
  date: "2025-10-29",
  duration: "4h 10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1904,
  date: "2025-10-29",
  duration: "2h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1905,
  date: "2025-10-29",
  duration: "4h 32m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.55
}, {
  tradeNumber: 1906,
  date: "2025-10-30",
  duration: "1h 55m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.87
}, {
  tradeNumber: 1907,
  date: "2025-10-30",
  duration: "1h 02m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1908,
  date: "2025-10-30",
  duration: "7m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1909,
  date: "2025-10-30",
  duration: "20h 50m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.66
}, {
  tradeNumber: 1910,
  date: "2025-10-31",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 4.4
}, {
  tradeNumber: 1911,
  date: "2025-11-03",
  duration: "7m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1912,
  date: "2025-11-03",
  duration: "31m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1913,
  date: "2025-11-04",
  duration: "3h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1914,
  date: "2025-11-04",
  duration: "3h 40m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.17
}, {
  tradeNumber: 1915,
  date: "2025-11-04",
  duration: "3h 31m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1916,
  date: "2025-11-05",
  duration: "17m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1917,
  date: "2025-11-06",
  duration: "6h 07m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.88
}, {
  tradeNumber: 1918,
  date: "2025-11-06",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 10.83
}, {
  tradeNumber: 1919,
  date: "2025-11-06",
  duration: "22m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1920,
  date: "2025-11-07",
  duration: "49m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1921,
  date: "2025-11-07",
  duration: "5h 11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1922,
  date: "2025-11-09",
  duration: "4h 12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1923,
  date: "2025-11-10",
  duration: "24m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1924,
  date: "2025-11-10",
  duration: "1h 14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1925,
  date: "2025-11-11",
  duration: "47m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1926,
  date: "2025-11-12",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.41
}, {
  tradeNumber: 1927,
  date: "2025-11-12",
  duration: "9h 21m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.87
}, {
  tradeNumber: 1928,
  date: "2025-11-13",
  duration: "28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1929,
  date: "2025-11-14",
  duration: "6h 18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 3.44
}, {
  tradeNumber: 1930,
  date: "2025-11-17",
  duration: "4h 01m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.67
}, {
  tradeNumber: 1931,
  date: "2025-11-17",
  duration: "1h 24m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.68
}, {
  tradeNumber: 1932,
  date: "2025-11-17",
  duration: "3m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1933,
  date: "2025-11-18",
  duration: "1m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1934,
  date: "2025-11-18",
  duration: "11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1935,
  date: "2025-11-19",
  duration: "11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1936,
  date: "2025-11-20",
  duration: "1h 26m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1937,
  date: "2025-11-21",
  duration: "2h 01m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.45
}, {
  tradeNumber: 1938,
  date: "2025-11-21",
  duration: "2m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1939,
  date: "2025-11-24",
  duration: "6h 28m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 5.1
}, {
  tradeNumber: 1940,
  date: "2025-11-25",
  duration: "3h 01m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.91
}, {
  tradeNumber: 1941,
  date: "2025-11-25",
  duration: "2h 49m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1942,
  date: "2025-11-26",
  duration: "1h 48m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1943,
  date: "2025-11-26",
  duration: "30m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.0
}, {
  tradeNumber: 1944,
  date: "2025-11-27",
  duration: "3h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.08
}, {
  tradeNumber: 1945,
  date: "2025-11-28",
  duration: "3h 14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1946,
  date: "2025-12-01",
  duration: "8m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1947,
  date: "2025-12-02",
  duration: "13h 04m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.04
}, {
  tradeNumber: 1948,
  date: "2025-12-02",
  duration: "6m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1949,
  date: "2025-12-03",
  duration: "13h 11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.04
}, {
  tradeNumber: 1950,
  date: "2025-12-03",
  duration: "20h 20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1951,
  date: "2025-12-04",
  duration: "1h 32m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1952,
  date: "2025-12-05",
  duration: "11h 39m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.16
}, {
  tradeNumber: 1953,
  date: "2025-12-05",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.12
}, {
  tradeNumber: 1954,
  date: "2025-12-05",
  duration: "34m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1955,
  date: "2025-12-08",
  duration: "54h 15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.59
}, {
  tradeNumber: 1956,
  date: "2025-12-08",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.34
}, {
  tradeNumber: 1957,
  date: "2025-12-09",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.7
}, {
  tradeNumber: 1958,
  date: "2025-12-10",
  duration: "4h 30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1959,
  date: "2025-12-11",
  duration: "10m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1960,
  date: "2025-12-12",
  duration: "9m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1961,
  date: "2025-12-15",
  duration: "3m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1962,
  date: "2025-12-15",
  duration: "12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1963,
  date: "2025-12-15",
  duration: "1h 43m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1964,
  date: "2025-12-16",
  duration: "25m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1965,
  date: "2025-12-16",
  duration: "3h 36m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.67
}, {
  tradeNumber: 1966,
  date: "2025-12-17",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 16.95
}, {
  tradeNumber: 1967,
  date: "2025-12-17",
  duration: "52m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1968,
  date: "2025-12-18",
  duration: "35h 16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 5.43
}, {
  tradeNumber: 1969,
  date: "2025-12-18",
  duration: "8m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1970,
  date: "2025-12-19",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.53
}, {
  tradeNumber: 1971,
  date: "2025-12-22",
  duration: "6h 21m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1972,
  date: "2025-12-22",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1973,
  date: "2025-12-23",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 3.43
}, {
  tradeNumber: 1974,
  date: "2025-12-23",
  duration: "3h 50m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1975,
  date: "2025-12-24",
  duration: "2h 30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.01
}, {
  tradeNumber: 1976,
  date: "2025-12-24",
  duration: "2h 01m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1977,
  date: "2025-12-26",
  duration: "170h 17m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 19.14
}, {
  tradeNumber: 1978,
  date: "2025-12-26",
  duration: "20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1979,
  date: "2025-12-30",
  duration: "16m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 1980,
  date: "2025-12-31",
  duration: "6h 15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.49
}, {
  tradeNumber: 1981,
  date: "2026-01-02",
  duration: "7m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1982,
  date: "2026-01-05",
  duration: "18h 47m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.07
}, {
  tradeNumber: 1983,
  date: "2026-01-05",
  duration: "4m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1984,
  date: "2026-01-06",
  duration: "20m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1985,
  date: "2026-01-06",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 5.23
}, {
  tradeNumber: 1986,
  date: "2026-01-07",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.02
}, {
  tradeNumber: 1987,
  date: "2026-01-08",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1988,
  date: "2026-01-08",
  duration: "6h 19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.11
}, {
  tradeNumber: 1989,
  date: "2026-01-09",
  duration: "2h 10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1990,
  date: "2026-01-09",
  duration: "7m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1991,
  date: "2026-01-09",
  duration: "58h 58m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.15
}, {
  tradeNumber: 1992,
  date: "2026-01-12",
  duration: "50h 22m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.07
}, {
  tradeNumber: 1993,
  date: "2026-01-12",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1994,
  date: "2026-01-13",
  duration: "9m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1995,
  date: "2026-01-14",
  duration: "4m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1996,
  date: "2026-01-14",
  duration: "6h 18m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.63
}, {
  tradeNumber: 1997,
  date: "2026-01-15",
  duration: "1h 45m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1998,
  date: "2026-01-15",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 1999,
  date: "2026-01-16",
  duration: "14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2000,
  date: "2026-01-19",
  duration: "2h 18m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2001,
  date: "2026-01-19",
  duration: "12h 09m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.0
}, {
  tradeNumber: 2002,
  date: "2026-01-19",
  duration: "32m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 2003,
  date: "2026-01-20",
  duration: "4h 00m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 2004,
  date: "2026-01-21",
  duration: "2h 42m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.95
}, {
  tradeNumber: 2005,
  date: "2026-01-21",
  duration: "2h 17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2006,
  date: "2026-01-22",
  duration: "50m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2007,
  date: "2026-01-22",
  duration: "1h 55m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.87
}, {
  tradeNumber: 2008,
  date: "2026-01-22",
  duration: "2h 49m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2009,
  date: "2026-01-23",
  duration: "56h 59m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.03
}, {
  tradeNumber: 2010,
  date: "2026-01-23",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.86
}, {
  tradeNumber: 2011,
  date: "2026-01-26",
  duration: "38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2012,
  date: "2026-01-26",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.46
}, {
  tradeNumber: 2013,
  date: "2026-01-27",
  duration: "2h 06m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2014,
  date: "2026-01-27",
  duration: "4h 00m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2015,
  date: "2026-01-27",
  duration: "25m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2016,
  date: "2026-01-28",
  duration: "15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2017,
  date: "2026-01-28",
  duration: "5h 47m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.98
}, {
  tradeNumber: 2018,
  date: "2026-01-29",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.34
}, {
  tradeNumber: 2019,
  date: "2026-01-29",
  duration: "12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2020,
  date: "2026-01-30",
  duration: "6m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2021,
  date: "2026-02-01",
  duration: "27m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2022,
  date: "2026-02-02",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 6.26
}, {
  tradeNumber: 2023,
  date: "2026-02-02",
  duration: "27m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2024,
  date: "2026-02-02",
  duration: "17h 42m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 4.51
}, {
  tradeNumber: 2025,
  date: "2026-02-03",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 11.51
}, {
  tradeNumber: 2026,
  date: "2026-02-04",
  duration: "4h 57m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 5.95
}, {
  tradeNumber: 2027,
  date: "2026-02-04",
  duration: "2m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2028,
  date: "2026-02-05",
  duration: "20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2029,
  date: "2026-02-05",
  duration: "15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2030,
  date: "2026-02-06",
  duration: "2m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2031,
  date: "2026-02-06",
  duration: "3h 44m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2032,
  date: "2026-02-09",
  duration: "9m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2033,
  date: "2026-02-09",
  duration: "48h 57m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.65
}, {
  tradeNumber: 2034,
  date: "2026-02-10",
  duration: "15m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2035,
  date: "2026-02-11",
  duration: "6h 03m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.72
}, {
  tradeNumber: 2036,
  date: "2026-02-12",
  duration: "6h 53m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.0
}, {
  tradeNumber: 2037,
  date: "2026-02-12",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 6.75
}, {
  tradeNumber: 2038,
  date: "2026-02-13",
  duration: "7h 51m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2039,
  date: "2026-02-13",
  duration: "1h 11m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.69
}, {
  tradeNumber: 2040,
  date: "2026-02-13",
  duration: "5m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2041,
  date: "2026-02-16",
  duration: "15h 58m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.86
}, {
  tradeNumber: 2042,
  date: "2026-02-16",
  duration: "3h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -0.11
}, {
  tradeNumber: 2043,
  date: "2026-02-17",
  duration: "11m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2044,
  date: "2026-02-17",
  duration: "46m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.8
}, {
  tradeNumber: 2045,
  date: "2026-02-17",
  duration: "20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2046,
  date: "2026-02-17",
  duration: "6m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2047,
  date: "2026-02-17",
  duration: "2h 20m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -0.43
}, {
  tradeNumber: 2048,
  date: "2026-02-18",
  duration: "4h 02m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2049,
  date: "2026-02-18",
  duration: "25m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2050,
  date: "2026-02-19",
  duration: "27m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2051,
  date: "2026-02-19",
  duration: "2h 39m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2052,
  date: "2026-02-20",
  duration: "63h 40m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.0
}, {
  tradeNumber: 2053,
  date: "2026-02-20",
  duration: "2m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2054,
  date: "2026-02-23",
  duration: "12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2055,
  date: "2026-02-23",
  duration: "11h 44m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.82
}, {
  tradeNumber: 2056,
  date: "2026-02-24",
  duration: "2h 25m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 1.06
}, {
  tradeNumber: 2057,
  date: "2026-02-24",
  duration: "14m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2058,
  date: "2026-02-25",
  duration: "12h 54m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2059,
  date: "2026-02-25",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.14
}, {
  tradeNumber: 2060,
  date: "2026-02-26",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 5.01
}, {
  tradeNumber: 2061,
  date: "2026-02-26",
  duration: "17m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2062,
  date: "2026-02-27",
  duration: "3m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2063,
  date: "2026-03-01",
  duration: "6h 45m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2064,
  date: "2026-03-02",
  duration: "12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2065,
  date: "2026-03-03",
  duration: "27m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2066,
  date: "2026-03-03",
  duration: "34m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2067,
  date: "2026-03-03",
  duration: "4h 14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.2
}, {
  tradeNumber: 2068,
  date: "2026-03-04",
  duration: "0m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.0
}, {
  tradeNumber: 2069,
  date: "2026-03-05",
  duration: "1h 12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.66
}, {
  tradeNumber: 2070,
  date: "2026-03-05",
  duration: "36m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.64
}, {
  tradeNumber: 2071,
  date: "2026-03-05",
  duration: "9m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2072,
  date: "2026-03-06",
  duration: "13m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2073,
  date: "2026-03-09",
  duration: "12m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2074,
  date: "2026-03-09",
  duration: "33m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.53
}, {
  tradeNumber: 2075,
  date: "2026-03-10",
  duration: "3h 17m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.56
}, {
  tradeNumber: 2076,
  date: "2026-03-11",
  duration: "4h 58m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.79
}, {
  tradeNumber: 2077,
  date: "2026-03-11",
  duration: "57m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 2078,
  date: "2026-03-11",
  duration: "23h 53m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 4.54
}, {
  tradeNumber: 2079,
  date: "2026-03-12",
  duration: "6h 28m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 2.16
}, {
  tradeNumber: 2080,
  date: "2026-03-12",
  duration: "11h 15m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2081,
  date: "2026-03-13",
  duration: "1h 50m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2082,
  date: "2026-03-13",
  duration: "12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2083,
  date: "2026-03-16",
  duration: "17h 23m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.74
}, {
  tradeNumber: 2084,
  date: "2026-03-17",
  duration: "2h 04m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -2.01
}, {
  tradeNumber: 2085,
  date: "2026-03-18",
  duration: "3h 54m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2086,
  date: "2026-03-19",
  duration: "4h 50m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2087,
  date: "2026-03-19",
  duration: "12h 27m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.63
}, {
  tradeNumber: 2088,
  date: "2026-03-20",
  duration: "6h 09m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 3.02
}, {
  tradeNumber: 2089,
  date: "2026-03-23",
  duration: "19m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2090,
  date: "2026-03-24",
  duration: "8h 13m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.43
}, {
  tradeNumber: 2091,
  date: "2026-03-24",
  duration: "2h 24m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.52
}, {
  tradeNumber: 2092,
  date: "2026-03-24",
  duration: "1h 12m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -2.0
}, {
  tradeNumber: 2093,
  date: "2026-03-25",
  duration: "4h 02m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.65
}, {
  tradeNumber: 2094,
  date: "2026-03-25",
  duration: "36m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2095,
  date: "2026-03-25",
  duration: "1h 10m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.61
}, {
  tradeNumber: 2096,
  date: "2026-03-25",
  duration: "1h 09m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.66
}, {
  tradeNumber: 2097,
  date: "2026-03-26",
  duration: "1h 09m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2098,
  date: "2026-03-27",
  duration: "4m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2099,
  date: "2026-03-30",
  duration: "5m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2100,
  date: "2026-03-31",
  duration: "58m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2101,
  date: "2026-03-31",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 11.15
}, {
  tradeNumber: 2102,
  date: "2026-04-01",
  duration: "1h 10m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2103,
  date: "2026-04-01",
  duration: "3h 38m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2104,
  date: "2026-04-01",
  duration: "5h 37m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.06
}, {
  tradeNumber: 2105,
  date: "2026-04-02",
  duration: "3h 22m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 5.3
}, {
  tradeNumber: 2106,
  date: "2026-04-02",
  duration: "6h 29m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 4.87
}, {
  tradeNumber: 2107,
  date: "2026-04-03",
  duration: "1h 21m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 1.12
}, {
  tradeNumber: 2108,
  date: "2026-04-06",
  duration: "1h 09m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: 0.9
}, {
  tradeNumber: 2109,
  date: "2026-04-06",
  duration: "5h 59m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2110,
  date: "2026-04-06",
  duration: "6h 48m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.77
}, {
  tradeNumber: 2111,
  date: "2026-04-07",
  duration: "1h 14m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.77
}, {
  tradeNumber: 2112,
  date: "2026-04-09",
  duration: "8h 16m",
  asset: "NASDAQ",
  type: "Long",
  tradeReturnPct: 0.91
}, {
  tradeNumber: 2113,
  date: "2026-04-10",
  duration: "11h 30m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2114,
  date: "2026-04-13",
  duration: "1h 39m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2115,
  date: "2026-04-14",
  duration: "1h 44m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}, {
  tradeNumber: 2116,
  date: "2026-04-15",
  duration: "1h 52m",
  asset: "NASDAQ",
  type: "Short",
  tradeReturnPct: -1.0
}];
const PAGE_SIZE = 50;
export default function HistoricalLedger() {
  const [page, setPage] = useState(0);
  const totalPages = Math.ceil(backtestTrades.length / PAGE_SIZE);
  const visibleTrades = useMemo(() => backtestTrades.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE), [page]);
  const startIdx = page * PAGE_SIZE + 1;
  const endIdx = Math.min((page + 1) * PAGE_SIZE, backtestTrades.length);
  return <section id="historical-ledger" className="dark bg-background text-foreground py-24 px-4 sm:px-8 lg:px-16 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="mb-12 flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div className="max-w-2xl">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4">
              <span className="text-foreground">Backtest</span>{" "}
              <span className="text-primary">Ledger</span>
            </h2>
            <p className="text-muted-foreground text-lg">
              Complete trade-by-trade history from the ImperiumAlgo backtest on NASDAQ futures (May 2021 - Apr 2026), 1% risk per trade.
            </p>
          </div>
        </div>

        <Card className="border-border/50 bg-card/50 backdrop-blur-sm shadow-2xl overflow-hidden">
          <div className="overflow-x-auto">
            <Table>
              <TableHeader className="bg-card/95 backdrop-blur-md border-b border-border/50">
                <TableRow className="hover:bg-transparent">
                  <TableHead className="text-muted-foreground font-medium py-4">#</TableHead>
                  <TableHead className="text-muted-foreground font-medium py-4">Date</TableHead>
                  <TableHead className="text-muted-foreground font-medium py-4">Duration</TableHead>
                  <TableHead className="text-muted-foreground font-medium py-4">Asset</TableHead>
                  <TableHead className="text-muted-foreground font-medium py-4">Type</TableHead>
                  <TableHead className="text-muted-foreground font-medium py-4 text-right">Net P/L %</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {visibleTrades.map((trade, i) => {
                const isProfit = trade.tradeReturnPct > 0;
                const formattedPct = (isProfit ? "+" : "") + trade.tradeReturnPct.toFixed(2) + "%";
                return <TableRow key={trade.tradeNumber} data-index={i} className="border-b border-border/30 even:bg-muted/5 odd:bg-transparent transition-colors hover:bg-muted/20">
                      <TableCell className="font-mono text-xs text-muted-foreground">
                        {trade.tradeNumber}
                      </TableCell>
                      <TableCell className="text-sm text-foreground whitespace-nowrap">
                        {trade.date}
                      </TableCell>
                      <TableCell className="text-sm text-muted-foreground">
                        {trade.duration}
                      </TableCell>
                      <TableCell className="font-medium text-foreground">
                        {trade.asset}
                      </TableCell>
                      <TableCell>
                        <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium ${trade.type === "Long" ? "bg-emerald-500/10 text-emerald-500" : "bg-rose-500/10 text-rose-500"}`}>
                          {trade.type === "Long" ? <ArrowUpRight className="w-3 h-3" /> : <ArrowDownRight className="w-3 h-3" />}
                          {trade.type}
                        </span>
                      </TableCell>
                      <TableCell className="text-right">
                        <span className={`font-mono font-medium ${isProfit ? "text-emerald-500" : "text-rose-500"}`}>
                          {formattedPct}
                        </span>
                      </TableCell>
                    </TableRow>;
              })}
              </TableBody>
            </Table>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 px-6 py-4 border-t border-border/50 bg-card/50">
            <p className="text-sm text-muted-foreground font-mono">
              Showing <span className="text-foreground">{startIdx}-{endIdx}</span> of{" "}
              <span className="text-foreground">{backtestTrades.length}</span> trades
            </p>
            <div className="flex items-center gap-2">
              <Button variant="outline" size="sm" onClick={() => setPage(p => Math.max(0, p - 1))} disabled={page === 0} className="h-8 px-3">
                <ChevronLeft className="w-4 h-4 mr-1" />
                Prev
              </Button>
              <span className="text-sm text-muted-foreground font-mono px-2">
                Page <span className="text-foreground">{page + 1}</span> /{" "}
                <span className="text-foreground">{totalPages}</span>
              </span>
              <Button variant="outline" size="sm" onClick={() => setPage(p => Math.min(totalPages - 1, p + 1))} disabled={page >= totalPages - 1} className="h-8 px-3">
                Next
                <ChevronRight className="w-4 h-4 ml-1" />
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </section>;
}